/* ===============================
   🎄 CHRISTMAS BREAK ORDER BLOCK
   Active: 18 Dec 2025 → 4 Jan 2026
   Remove entirely on: 5 Jan 2026
================================ */

const CHRISTMAS_BLOCK = {
  enabled: true, // ← set to false OR delete block on Jan 5
  start: new Date('2025-12-18T00:00:00+11:00'),
  end:   new Date('2026-01-04T23:59:59+11:00'),
  allowedSkuSuffix: '_D'
};

function isChristmasBlockActive() {
  if (!CHRISTMAS_BLOCK.enabled) return false;
  const now = new Date();
  return now >= CHRISTMAS_BLOCK.start && now <= CHRISTMAS_BLOCK.end;
}

function isAllowedGift(gift) {
  return gift.format.toLowerCase() === "digital";
}




const customerEmail = window.customerEmail;

// Currency formatter
const formatCurrency = (amount, currency = 'AUD', locale = 'en-AU') => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount);
};

// Configurable format options with pricing
const GIFT_FORMAT_CONFIG = {
    "Experience Collections": {
        formats: [
            {
                name: "Portfolio",
                packaging_price: 25,
                shipping_price: 10,
                variant_id: 45962011345148,
                description: "Delivered to Address",
                image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Portfolio_Collection.jpg?v=1755672916"
            },
            {
                name: "Card & Keys",
                packaging_price: 20,
                shipping_price: 5,
                variant_id: 45962011279612,
                description: "Delivered to Address",
                image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Card_Key.jpg?v=1755672916"
            },
            {
                name: "Digital",
                packaging_price: 0,
                shipping_price: 0,
                description: "Instant delivery via email to Gift Recipient",
                image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Digital_Collection.jpg?v=1755672915"
            }
        ],
        personalisation: {
            enabled: true,
            features: ["Image", "Message"]
        },
        image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/experiencecollection-category.jpg?v=1756326010"
    },
    "Home Hampers": {
        formats: [
            {
                name: "Hamper Pack",
                packaging_price: 0,
                shipping_price: 15,
                variant_id: 45962011672828,
                description: "Premium gift packaging",
                image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/We_Wander_Generic_Hamper_close_up_-_adjusted_colours.jpg?v=1745988451"
            }
        ],
        personalisation: {
            enabled: false,
            features: []
        },
        image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/hampers-category.png?v=1756326012"
    },
    "Gift Cards": {
        formats: [
            {
                name: "Card",
                packaging_price: 15,
                shipping_price: 5,
                variant_id: 45962011279612,
                description: "Delivered to Address",
                image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/We_Wander_Gift_Card_Square_Wine_68298f5c-c913-4dea-aa35-a004b249279d.jpg?v=1743378355"

            },
            {
                name: "Digital",
                packaging_price: 0,
                shipping_price: 0,
                description: "Instant delivery via email",
                image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Digital_Collection.jpg?v=1755672915"
            }
        ],
        personalisation: {
            enabled: true,
            features: ["Image", "Message"]
        },
        image: "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/giftcards-category.png?v=1756326013"
    }
};

// State management
let recipients = [];
let selectedRecipient = null;
let selectedGift = null;
let deliveryMethod = 'now';
let deliveryDestination = 'office';
let recipientGifts = {}; // Store gifts for each recipient
let cart = []; // Store complete orders


/* ================== AUTOSAVE / RESUME DRAFT (customer metafield mirror) ================== */
// Lightweight, schema-versioned autosave so users can resume later.
// If the customer is logged in and you expose window.Shopify.customerId and window.SAVED_DRAFT from Liquid,
// this will mirror the draft to the customer metafield b2b.savedGiftDraft via your backend app proxy.

(function(){
  const AUTOSAVE_KEY = "giftDraft:v1";

  function getRecipientsRef() {
    try { return typeof recipients !== "undefined" ? recipients : (window.recipients || []); }
    catch { return window.recipients || []; }
  }

  function getRecipientGiftsRef() {
    try { return typeof recipientGifts !== "undefined" ? recipientGifts : (window.recipientGifts || {}); }
    catch { return window.recipientGifts || {}; }
  }

  function serializeDraft() {
    const recs = getRecipientsRef();
    const giftsMap = getRecipientGiftsRef();

    // Deep clone and strip out dataUrl from coverImage to reduce size
    const sanitizedGiftsMap = {};
    for (const recipientId in giftsMap) {
      const gift = giftsMap[recipientId];
      sanitizedGiftsMap[recipientId] = {
        ...gift,
        personalisation: gift.personalisation ? {
          ...gift.personalisation,
          coverImage: gift.personalisation.coverImage ? {
            // If serverUrl exists, use it (new format - exclude dataUrl to save space)
            // If serverUrl doesn't exist, keep dataUrl (backward compatibility for old drafts)
            ...(gift.personalisation.coverImage.serverUrl 
              ? {
                  serverUrl: gift.personalisation.coverImage.serverUrl,
                  fileName: gift.personalisation.coverImage.fileName,
                  fileType: gift.personalisation.coverImage.fileType
                }
              : {
                  dataUrl: gift.personalisation.coverImage.dataUrl,
                  fileName: gift.personalisation.coverImage.fileName,
                  fileType: gift.personalisation.coverImage.fileType
                }
            )
          } : null
        } : null
      };
    }

    // OPTIMIZATION: Don't save recipients array - it will be rebuilt from recipientGifts on load
    // This reduces metafield size and eliminates data duplication
    // Recipient data is already stored in each recipientGifts[id].recipient
    // The applyDraft() function automatically rebuilds the recipients array when loading

    return {
      version: 1,
      updatedAt: new Date().toISOString(),
      step: (typeof window.currentStep !== "undefined" ? window.currentStep : null),
      orderName: (document.getElementById('orderName') ? document.getElementById('orderName').value : ""),
      // recipients: [],  // ← REMOVED: No longer saved, rebuilt from recipientGifts on load
      recipientGifts: sanitizedGiftsMap
    };
  }

  function applyDraft(draft) {
    // write back into the actual bindings if they exist
    const hasRecipients = (typeof recipients !== "undefined");
    const hasRecipientGifts = (typeof recipientGifts !== "undefined");

    // First, load recipientGifts data
    if (hasRecipientGifts) {
      // replace contents without changing reference (safer for bindings)
      for (const k of Object.keys(recipientGifts)) delete recipientGifts[k];
      Object.assign(recipientGifts, draft.recipientGifts || {});
    } else {
      window.recipientGifts = draft.recipientGifts || {};
    }

    // Get references for processing
    const recipientsRef = hasRecipients ? recipients : window.recipients;
    const giftsRef = hasRecipientGifts ? recipientGifts : window.recipientGifts;

    // Clear existing recipients array
    if (hasRecipients) {
      recipients.length = 0;
    } else {
      window.recipients = [];
    }

    // CRITICAL: Always rebuild recipients array from recipientGifts data
    // This ensures recipients are properly loaded even when the saved draft has an empty recipients array
    if (giftsRef && Object.keys(giftsRef).length > 0) {
      console.log('[Draft Resume] Rebuilding recipients from recipientGifts data...');
      
      // Use a Map to deduplicate recipients with the same ID
      const recipientMap = new Map();
      
      Object.keys(giftsRef).forEach(recipientId => {
        const giftData = giftsRef[recipientId];
        if (giftData && giftData.recipient) {
          const recipient = giftData.recipient;
          
          // Validate recipient has required fields
          if (recipient.id && recipient.name) {
            // Only add if not already in map (avoid duplicates)
            if (!recipientMap.has(recipient.id)) {
              // Create a clean recipient object
              const cleanRecipient = {
                id: recipient.id,
                name: recipient.name,
                email: recipient.email || '',
                phone: recipient.phone || '',
                address: recipient.address || ''
              };
              
              // Preserve isPlaceholder flag if it exists
              if (recipient.isPlaceholder) {
                cleanRecipient.isPlaceholder = true;
              }
              
              recipientMap.set(recipient.id, cleanRecipient);
              console.log('[Draft Resume] Added recipient:', cleanRecipient.name, '(ID:', cleanRecipient.id + ')');
            }
          } else {
            console.warn('[Draft Resume] Skipping invalid recipient in gift data:', recipientId);
          }
        }
      });
      
      // Convert map values back to array and push to recipients
      recipientMap.forEach(recipient => {
        (hasRecipients ? recipients : window.recipients).push(recipient);
      });
      
      console.log('[Draft Resume] Loaded', recipientMap.size, 'recipients from recipientGifts');
    } else {
      console.log('[Draft Resume] No recipientGifts data to load');
    }
    
    // Fallback: If still no recipients but draft.recipients exists, use it
    if ((hasRecipients ? recipients : window.recipients).length === 0 && draft.recipients && draft.recipients.length > 0) {
      console.log('[Draft Resume] Falling back to draft.recipients array');
      (draft.recipients || []).forEach(r => {
        (hasRecipients ? recipients : window.recipients).push(r);
      });
    }

    window.currentStep = draft.step || 1;

    const on = document.getElementById('orderName');
    if (on && draft.orderName) on.value = draft.orderName;

    if (typeof updateStep1RecipientsList === "function") updateStep1RecipientsList();
    if (typeof renderRecipientSelectionList === "function") renderRecipientSelectionList();
    if (typeof goToStep === "function" && draft.step) goToStep(draft.step);
  }

  // simple debounce
  function debounce(fn, wait=800){ let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), wait); }; }

  async function persistDraftToServer(draft) {
    if (!window.Shopify || !window.Shopify.customerId) return;

    let param = {
        "customerid" : window.Shopify.customerId,
        metafieldNamespace: "b2b",
        metafieldKey: "savedgiftdraft",
        value: JSON.stringify(draft),
        "type": "json",
        "bjson": 1,
        "timestamp": window.timestamp,
        "check": window.passpin
      };
    
    try {
      let data = await $.ajax({
        type: "POST",
        url: 'https://www.we-wa.com.au/wp-json/shopify/v1/updateCustGivenMetafieldShopify',
        contentType: "application/json", // Set content type to application/json
        dataType: "json",
        data: JSON.stringify(param),
      });
      
      if(data.result < 0) {
        showHtmlAlert(data.message);
        return 0;
      } else {
        return 1;
      }
    } catch (err) {
      console.warn("persistDraftToServer error:", err);
      showHtmlAlert("There's a technical issue…");
      return 0;
    }
  }

  const queueAutosave = debounce(() => {
    const draft = serializeDraft();
    if (!draft) return;
    try { localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(draft)); } catch (_){}
    persistDraftToServer(draft);
  }, 800);

  function tryRestoreDraftOnLoad() {
    console.log('[Draft Load] Attempting to restore draft...');
    
    let draft = null;
    
    // Try to load from server (Shopify metafield via window.SAVED_DRAFT)
    if (window.SAVED_DRAFT) {
      try {
        // Handle if SAVED_DRAFT is a string or already an object
        draft = (typeof window.SAVED_DRAFT === 'string') 
          ? JSON.parse(window.SAVED_DRAFT) 
          : window.SAVED_DRAFT;
        console.log('[Draft Load] Found server draft, updated:', draft?.updatedAt);
      } catch (err) {
        console.warn('[Draft Load] Failed to parse server draft:', err);
      }
    }

    if(!draft) {
      // Try to load from localStorage
      try { 
        const localData = localStorage.getItem(AUTOSAVE_KEY);
        if (localData) {
          draft = JSON.parse(localData);
          console.log('[Draft Load] Found localStorage draft, updated:', draft?.updatedAt);
        }
      } catch (err) {
        console.warn('[Draft Load] Failed to parse localStorage draft:', err);
      }
    }
    
    // Apply the draft if it has data
    if (draft && (draft.recipients?.length || Object.keys(draft.recipientGifts||{}).length)) {
      console.log('[Draft Load] Applying draft with', Object.keys(draft.recipientGifts||{}).length, 'recipientGifts');
      applyDraft(draft);
    } else {
      console.log('[Draft Load] No valid draft data to apply');
    }
  }

  function clearDraftEverywhere() {
    try { localStorage.removeItem(AUTOSAVE_KEY); } catch (_){}
    persistDraftToServer("");
  }

  // Expose a couple for other functions
  window.__giftDraft__ = { queueAutosave, tryRestoreDraftOnLoad, clearDraftEverywhere };

  // Auto-restore on page ready
  document.addEventListener("DOMContentLoaded", () => {
      if (!isChristmasBlockActive()) {
        const params = new URLSearchParams(location.search);
        if (params.get("resumeDraft") === "0") {
            clearDraftEverywhere();
        } else {
            tryRestoreDraftOnLoad();
        }
      }
      
      // Update button visibility based on recipients
      const selectBtn = document.getElementById('selectGiftsBtn');
      const skipBtn = document.getElementById('skipRecipientsBtn');
      const recs = (typeof recipients !== "undefined") ? recipients : (window.recipients || []);
      
      if (Array.isArray(recs) && recs.length > 0) {
          if (selectBtn) selectBtn.style.display = 'inline-block';
          if (skipBtn) skipBtn.style.display = 'none';
      } else {
          if (selectBtn) selectBtn.style.display = 'none';
          if (skipBtn) skipBtn.style.display = 'inline-block';
      }

      try { ensureNextButton(); } catch(_) {}
  });
})();
/* ================== /AUTOSAVE ================== */

let isUpdatingFromStep4 = false; // Flag to track if we're updating from step 4

// Sample gift data
let gifts = null;
let customPresetGifts = null;
if(window.customerPresetGiftJson && window.customerPresetGiftJson != '') {
  customPresetGifts = JSON.parse(window.customerPresetGiftJson);  // Remove 'let' to use the outer variable
}
if(customPresetGifts && Array.isArray(customPresetGifts)) {
  gifts = customPresetGifts;
} else {
  gifts = [];
  // Default gifts commented out - uncomment to re-enable
  /*
  gifts = [
    { 
        id: 1, 
        title: 'Settlement Gift - Bucket List Portfolio', 
        type: 'saved', 
        basePrice: 100,
        price: 100, 
        category: 'Experience Collections',
        image: 'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/bucketlist-portfolio.jpg?v=1755485051',
        format: 'Portfolio',
        variant_id: 44472618483964,
        packaging_price: 25,
        shipping_price: 10,
        native: true
    },
    { 
        id: 2, 
        title: 'Premium Kitchen Gift Hamper', 
        type: 'hamper', 
        basePrice: 180,
        price: 180, 
        category: 'Home Hampers',
        image: 'https://wewander.com.au/cdn/shop/files/we-wander-kitchen-gift-hamper-587905.png?v=1747174109',
        format: 'Hamper Pack',
        packaging_price: 0,
        shipping_price: 15,
        variant_id: 47156086669564,
        native: true
    },
    { 
        id: 3, 
        title: 'Anniversary - $150 Gift Card Physical', 
        type: 'saved', 
        basePrice: 150,
        price: 150, 
        category: 'Gift Cards',
        image: 'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/We_Wander_Gift_Card_Square_Wine_68298f5c-c913-4dea-aa35-a004b249279d.jpg?v=1743378355',
        format: 'Card',
        variant_id: 46544878633212,
        packaging_price: 15,
        shipping_price: 5,
        native: true
    }
    // { 
    //     id: 4, 
    //     title: '$200 Wine & Dine Gift Card Digital', 
    //     type: 'giftcard', 
    //     basePrice: 225,
    //     price: 225, 
    //     category: 'Gift Cards',
    //     image: 'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/2024_Christmas_Landing_page_7.jpg?v=1724997380',
    //     format: 'Digital',
    //     variant_id: 46544878338300,
    //     packaging_price: 0,
    //     shipping_price: 0,
    //     native: true
    // }
  ];
  */
}

// Calculate total prices for existing gifts
gifts = gifts.map(gift => ({
    ...gift,
    price: gift.basePrice + (gift.packaging_price || 0) + (gift.shipping_price || 0)
}));

// Gift variant data for modal configuration
let experienceCollectionVariants = [
    {
        "handle": "essential-experience-portfolio-for-business",
        "title": "Essential",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 1-4 people</li><li>210+ experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/essentials-portfolio.jpg?v=1755485051",
        "price": 50,
        "Categories": "Experiences"
    },
    {
        "handle": "inspire-experience-portfolio-for-business",
        "title": "Inspire",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 1-4 people</li><li>440+ experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/inspire-portfolio.jpg?v=1755485051",
        "price": 80,
        "Categories": "Experiences"
    },
    {
        "handle": "bucket-list-experience-portfolio-for-business",
        "title": "Bucket List",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 1 to 4 people</li><li>600+ experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/bucketlist-portfolio.jpg?v=1755485051",
        "price": 100,
        "Categories": "Experiences, Most Popular"
    },
    {
        "handle": "gourmet-dining-experience-portfolio-for-business",
        "title": "Gourmet Dining",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 2 people</li><li>100+ premium foodie experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/gourmetdining-portfolio.jpg?v=1755485051",
        "price": 150,
        "Categories": "Experiences"
    },
    {
        "handle": "wanderlust-experience-portfolio-for-business",
        "title": "Wanderlust",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 1 to 4 people</li><li>810+ experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/wanderlust-portfolio.jpg?v=1755485051",
        "price": 200,
        "Categories": "Experiences"
    },
    {
        "handle": "ultimate-experience-portfolio-for-business",
        "title": "Ultimate",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 1 to 4 people</li><li>730+ experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/ultimate-portfolio.jpg?v=1755485051",
        "price": 300,
        "Categories": "Experiences, Most Popular"
    },
    {
        "handle": "unique-experience-portfolio-for-business",
        "title": "Unique",
        "description": "<ul><li>Multi-choice voucher valid for 3 years</li><li>Experiences for 1 to 4 people</li><li>430+ premium experiences hand-picked by our gift experts</li><li>Nation-wide offer</li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/unique-portfolio.jpg?v=1755485051",
        "price": 600,
        "Categories": "Experiences"
    },
    {
        "handle": "elite2-experience-portfolio-for-business",
        "title": "Elite 2",
        "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li><span>Over 130 superlative experiences meticulously selected by our elite gift experts</span></li><li><span>Nation-wide offer</span></li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/elite2-portfolio.jpg?v=1755485051",
        "price": 2000,
        "Categories": "Experiences"
    },
    {
        "handle": "nature-gateway-by-unyoked",
        "title": "Nature Getaway by Unyoked",
        "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li><span>A weekday retreat for two in an off grid cabins in nature, closer than you think</span></li><li><span>Nation-wide offer</span></li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/naturegetaway-portfolio.jpg?v=1755485051",
        "price": 280.00,
        "Categories": "Stays"
    },
    {
        "handle": "retreat-in-the-wild-by-unyoked",
        "title": "Retreat in the Wild by Unyoked",
        "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li><span>A two-night weekday adventure for two in an off grid cabins in nature, a short trip from home</span></li><li><span>Nation-wide offer</span></li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/retreadinthewild-portfolio.jpg?v=1755485051",
        "price": 550.00,
        "Categories": "Stays"
    },
    {
        "handle": "escape-off-the-grid-by-unyoked",
        "title": "Escape off the Grid by Unyoked",
        "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li><span>A two-night weekend getaway for two in an off grid cabins in nature, just hours from your front door</span></li><li><span>Nation-wide offer</span></li></ul>",
        "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/escapeoffthegrid-portfolio.jpg?v=1755485051",
        "price": 680.00,
        "Categories": "Stays, Most Popular"
    },
    {
      "handle": "movie-night-for-2",
      "title": "Movie Night for 2",
      "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li>Two-adult cinema tickets, valid at participating cinemas nation-wide</li><li>Popcorn and soft drinks included</li><li><span>Nation-wide offer</span></li></ul>",
      "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/movie-night-for-2-2028689.png",
      "price": 69.00,
      "Categories": "Night Out, Most Popular"
    },
    {
      "handle": "night-out-for-2",
      "title": "Night Out for 2",
      "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li>Two-adult cinema tickets at participating cinemas nation-wide</li><li>A $90 Wine & Dine gift card for restaurants across Australia</li><li>Nation-wide availability for both cinema and dining venues</li></ul>",
      "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/night-out-for-2-7549011.png",
      "price": 179.00,
      "Categories": "Night Out, Most Popular"
    },
    {
      "handle": "gold-class-night-out",
      "title": "Gold Class Night Out",
      "description": "<ul><li><span>Multi-choice voucher valid for 3 years</span></li><li>Two-adult gold class tickets at participating cinemas nation-wide</li><li>A $100 Wine & Dine gift card for restaurants across Australia</li><li>Nation-wide availability for both cinema and dining venues</li></ul>",
      "image": "https://cdn.shopify.com/s/files/1/0478/1221/4947/files/gold-class-night-out-2538975.png",
      "price": 195.00,
      "Categories": "Night Out, Most Popular"
    }
];

let homeHamperVariants = [
    {
        id: 'hamper_1',
        title: 'Luxury Bathroom Gift Hamper',
        price: 120,
        handle: "we-wander-bathroom-gift-hamper",
        sku: "BATHROOM_HAMPER",
        image: 'https://wewander.com.au/cdn/shop/files/we-wander-bathroom-gift-hamper-231154.png?v=1747174104'
    },
    {
        id: 'hamper_2',
        title: 'Premium Kitchen Gift Hamper',
        price: 180,
        handle: "we-wander-kitchen-gift-hamper",
        sku: "KITCHEN_HAMPER",
        image: 'https://wewander.com.au/cdn/shop/files/we-wander-kitchen-gift-hamper-587905.png?v=1747174109'
    },
    {
        id: 'hamper_3',
        title: 'Coastal Luxe Beach',
        price: 150,
        handle: "we-wander-coastal-luxe-beach-hamper",
        sku: "COASTAL_HAMPER",
        image: 'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/we-wander-coastal-luxe-beach-hamper-9801182.jpg'
    }
];

// Gift card carousel data - now dynamically loaded
let giftCardSlides = []; // Initialize as empty array

// Helper: extract state code from tags (e.g., "State_NSW" -> "NSW")
function getGiftCardStateFromTags(tags) {
  let list = [];
  if (Array.isArray(tags)) {
    list = tags;
  } else if (typeof tags === 'string') {
    list = tags.split(',').map(t => t.trim());
  }
  for (const t of list) {
    const m = /State[_-\s]*([A-Za-z]{2,3})/i.exec(t);
    if (m && m[1]) return m[1].toUpperCase();
  }
  return null;
}

// Function to fetch ALL gift card products from a Shopify collection (handles pagination)
async function fetchGiftCardSlides(handle = "gift-cards-national") {
  try {
    let page = 1;
    let allProducts = [];
    let hasMore = true;

    // Fetch all pages (Shopify storefront JSON caps at 30 products per page)
    while (hasMore) {
      const response = await fetch(`/collections/${handle}/products.json?page=${page}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      if (data.products && data.products.length > 0) {
        allProducts = allProducts.concat(data.products);
        page++;
      } else {
        hasMore = false;
      }
    }

    // Transform Shopify products into the expected format
    giftCardSlides = allProducts.map(product => {
      const state = getGiftCardStateFromTags(product.tags);
      return {
        url: product.url || `${window.location.origin}/products/${product.handle}`,
        image: (product.images && product.images.length > 0)
          ? (product.images[0].src || product.images[0].url)
          : product.featured_image,
        title: product.title.replace("eGift Card", ""),
        state
      };
    });

    console.log('Gift card slides loaded:', giftCardSlides.length, 'products');
    return giftCardSlides;

  } catch (error) {
    console.error('Error fetching gift card slides:', error);

    // Fallback to original static data if fetch fails
    giftCardSlides = [
      { url:'https://www.sirromet.com/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_1_8abaeab3-b85c-4672-8d55-06b7b3036755.jpg?v=1727701741', title:'Sirromet', caption:'QLD', state:'QLD' },
      { url:'https://vuedemonde.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_3_825b34dc-7f65-49e5-b5a2-5dbcd5a2ffea.jpg?v=1728880110', title:'Vue de Monde', caption:'VIC', state:'VIC' },
      { url:'https://www.skyfeastsydneytower.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_4c01f0cb-70a5-4037-9b63-ffceb8c41965.jpg?v=1727701781', title:'SkyFeast', caption:'NSW', state:'NSW' },
      { url:'https://www.delrios.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_-6_0203577b-c7e6-4b7a-ac42-0cc515196d84.png?v=1727832361', title:'del Rios', caption:'VIC', state:'VIC' },
      { url:'https://noburestaurants.com/sydney/home', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_2_a70d9b20-6997-4527-851b-a8a37426432a.jpg?v=1727702201', title:'Nobu', caption:'NSW', state:'NSW' },
      { url:'https://www.labellevie.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_4_d260a11b-1939-4d9c-8970-85359aa5eb0e.jpg?v=1728881128', title:'La Belle Vie', caption:'QLD', state:'QLD' },
      { url:'https://seppeltsfield.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_7.jpg?v=1728949987', title:'Seppeltsfield', caption:'SA', state:'SA' },
      { url:'https://www.voyagerestate.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_8.jpg?v=1728950458', title:'Voyager Estate', caption:'WA', state:'WA' },
      { url:'https://josefchromy.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_9.jpg?v=1728953543', title:'Josef Chromy', caption:'TAS', state:'TAS' },
      { url:'https://www.cottagepointinn.com.au/', image:'https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Recipient_Emaillanding_page_-_Gift_Card_-_10.jpg?v=1728954151', title:'Cottage Point Inn', caption:'NSW', state:'NSW' }
    ];

    return giftCardSlides;
  }
}



// Add recipient
document.getElementById('recipientForm').addEventListener('submit', function(e) {
    e.preventDefault();
    
    const recipient = {
        id: Date.now(),
        name: document.getElementById('recipientName').value,
        email: document.getElementById('recipientEmail').value,
        phone: document.getElementById('recipientPhone').value,
        address: document.getElementById('recipientAddress').value
    };
    
    recipients.push(recipient);
    updateStep1RecipientsList();
        if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();


    // move to '#step1RecipientsList'
    // window.location.hash = 'step1RecipientsList';
    
    // Clear form
    this.reset();
    
    // Show select gifts button if we have recipients
    if (recipients.length > 0) {
        document.getElementById('selectGiftsBtn').style.display = 'inline-block';
        document.getElementById('skipRecipientsBtn').style.display = 'none';
    }
});

document.getElementById('generateGreetingBtn').addEventListener('click', async () => { await generateAIMessage(selectedRecipient, 'this is my prompt'); });

async function generateAIMessage(selectedRecipient, prompt = null) {
    let greetingMessage = "";
    if(prompt) {
        const apiBody = JSON.stringify({
            action: 'generateGreeting',
            customerEmail: customerEmail,
            prompt: prompt.trim(),
            recipientName: selectedRecipient.name.trim()
        });

        let res;
        try {
        res = await fetch(
            'https://we-wa.com.au/wp-content/themes/golo/inc/ai/llm-helper.php',
            {
            method : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body   : apiBody
            }
        );
        } catch (networkErr) {
            throw new Error('Network/CORS error: ' + networkErr.message);
        }

        if (!res.ok) {
            const msg = await res.text();
            throw new Error(`Server returned ${res.status}: ${msg}`);
        }

        const { result } = await res.json();
        greetingMessage = result;
    } else {
        // Simulate AI message generation
        const messages = [
            "Wishing you joy and happiness on this special occasion! May your day be filled with love and laughter.",
            "Congratulations on this wonderful milestone! Here's to new adventures and cherished memories.",
            "Thinking of you and sending warm wishes your way. Hope this gift brings a smile to your face!"
        ];
        
        greetingMessage = messages[Math.floor(Math.random() * messages.length)];
    }
    document.getElementById('personalMessage').value = greetingMessage;
}

function updateStep1RecipientsList() {
    const listContainer = document.getElementById('step1RecipientsList');
    
    if (recipients.length === 0) {
        document.getElementById('recipientListEmpty').classList.remove('hidden');
        listContainer.innerHTML = '';
        return;
    }

    document.getElementById('recipientListEmpty').classList.add('hidden');
    
    let html = '';
    recipients.forEach(recipient => {
        const placeholderBadge = recipient.isPlaceholder ? '<span style="background:#ff9800;color:white;padding:2px 8px;border-radius:12px;font-size:11px;margin-left:8px;">PLACEHOLDER</span>' : ''
        let recipientDetails = "";
        if(recipient.email && recipient.phone) {
          recipientDetails = `${recipient.email} • ${recipient.phone}`;
        } else if(recipient.email) {
          recipientDetails = `${recipient.email}`;
        } else if(recipient.phone) {
          recipientDetails = `${recipient.phone}`;
        }
        if(recipient.address) {
          if(recipientDetails.length > 0) {
            recipientDetails = `<br>${recipient.address}`;
          } else {
            recipientDetails = `${recipient.address}`;
          }
        }
        html += `
            <div class="recipient-item">
                <div class="recipient-info">
                    <div class="recipient-name">${recipient.name}${placeholderBadge}</div>
                    <div class="recipient-details">
                        ${recipientDetails}
                    </div>
                </div>
                <button class="remove-btn" onclick="removeRecipient(${recipient.id})" title="Remove recipient"><i class="fa fa-trash"></i></button>
            </div>
        `;
    });
    
    listContainer.innerHTML = html;
}

function removeRecipient(id) {
    recipients = recipients.filter(r => r.id !== id);
    updateStep1RecipientsList();
        if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    renderRecipientSelectionList();
    if (recipients.length === 0) {
        document.getElementById('selectGiftsBtn').style.display = 'none';
        document.getElementById('skipRecipientsBtn').style.display = 'inline-block';
    } else {
        document.getElementById('selectGiftsBtn').style.display = 'inline-block';
        document.getElementById('skipRecipientsBtn').style.display = 'none';
    }

    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
}


function proceedToSelectGifts() {
    if (recipients.length === 0) {
        showHtmlAlert('Please add at least one recipient before proceeding.');
        return;
    }
    
    // Hide step 1 and show recipients list
    document.getElementById('step1').style.display = 'none';
    document.getElementById('recipientsList').classList.remove('hidden');
    
    // Update the recipients dropdown
    renderRecipientSelectionList();
    
    // Scroll to the recipients list section
    document.getElementById('recipientsList').scrollIntoView({ behavior: 'smooth' });
}

function skipAndProceedToSelectGifts() {
    // Create a placeholder recipient for gift browsing
    const placeholderRecipient = {
        id: Date.now(),
        name: 'Unassigned Gift',
        email: 'skip@example.com',
        phone: '0400000000',
        address: 'No shipping needed',
        isPlaceholder: true
    };
    
    // Add the placeholder recipient
    recipients.push(placeholderRecipient);
    updateStep1RecipientsList();
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    
    // Proceed to gift selection
    proceedToSelectGifts();
}

function renderRecipientGiftStatusHTML(recipientId) {
  const giftData = recipientGifts[recipientId];

  // ——— No gift yet: show a compact status + a Select Gift button (same spot/style as Edit) ———
  if (!giftData) {
    return `
      <div class="recipient-gift-status">
        <div style="flex:1;">
          <strong>No gift selected yet</strong>
          <div id="recipient-gift-action-btn-container" style="margin-top:6px;display:flex;gap:6px;flex-wrap:wrap;">
            <button class="btn btn-secondary"
                    onclick="selectGiftForRecipient(${recipientId}); event.stopPropagation();"
                    style="padding:6px 12px;font-size:12px;">
              Select Gift
            </button>
          </div>
        </div>
      </div>
    `;
  }

  // ——— Gift exists: keep your existing preview + Edit/Copy/Remove ———
  const g = giftData.gift || {};
  const priceHtml = g.price ? ` - ${formatCurrency(g.price)}` : '';
  const imgHtml = g.image
    ? `<div class="gift-image" style="width:120px;height:120px;margin-right:12px;"><img src="${g.image}" alt="${g.title}"></div>`
    : '';

  return `
    <div class="recipient-gift-status">
      ${imgHtml}
      <div style="flex:1;">
        <strong>Gift selected:</strong> ${g.title || ''}${priceHtml}
        ${g.format ? `<div>Format: ${g.format}</div>` : ''}
        <div id="recipient-gift-action-btn-container" style="margin-top:6px;display:flex;gap:6px;flex-wrap:wrap;">
          <button class="btn btn-secondary"
                  onclick="editRecipientGift(${recipientId}); event.stopPropagation();"
                  style="padding:6px 12px;font-size:12px;">
            Edit Gift
          </button>
          <button class="btn btn-secondary"
                  data-action="copy-gift"
                  onclick="copyRecipientGift(${recipientId}); event.stopPropagation();"
                  style="padding:6px 12px;font-size:12px;">
            Copy Gift
          </button>
          <button class="btn btn-secondary"
                  onclick="removeRecipientGift(${recipientId}); event.stopPropagation();"
                  style="padding:6px 12px;font-size:12px;">
            Remove Gift
          </button>
        </div>
      </div>
    </div>
  `;
}

function renderRecipientSelectionList() {
  const wrap = document.getElementById('recipientSelectList');
  if (!wrap) return;

  wrap.innerHTML = recipients.map(r => {
    const hasGift = !!recipientGifts[r.id];
    const isSelected = selectedRecipient && selectedRecipient.id === r.id;
    const placeholderBadge = r.isPlaceholder ? '<span style="background:#ff9800;color:white;padding:2px 8px;border-radius:12px;font-size:11px;margin-left:8px;">PLACEHOLDER</span>' : '';

    let recipientDetails = "";
    if(r.email && r.phone) {
      recipientDetails = `${r.email} • ${r.phone}`;
    } else if(r.email) {
      recipientDetails = `${r.email}`;
    } else if(r.phone) {
      recipientDetails = `${r.phone}`;
    }
    if(r.address) {
      if(recipientDetails.length > 0) {
        recipientDetails = `<br>${r.address}`;
      } else {
        recipientDetails = `${r.address}`;
      }
    }

    let giftStatusHtml = '';
    // if (isSelected) {
      giftStatusHtml = renderRecipientGiftStatusHTML(r.id);
    // }
    return `
      <div class="recipient-item selectable ${isSelected ? 'selected' : ''}" data-id="${r.id}" onclick="selectRecipientById(${r.id})">
        <div class="recipient-info">
          <div class="recipient-name">${r.name}${placeholderBadge}${hasGift ? ' ✓' : ''}</div>
          <div class="recipient-details">
            ${recipientDetails}
          </div>
        </div>
        <button class="remove-btn" onclick="event.stopPropagation(); removeRecipient(${r.id});" title="Remove recipient"><i class="fa fa-trash"></i></button>
        ${giftStatusHtml}
      </div>
    `;
  }).join('');
  
  if (recipients.length > 0) {
    document.getElementById('backToRecipientsBtn').classList.remove('hidden');
  }

  try { ensureCopyButtons(); } catch(_) {}
  try { ensureNextButton(); } catch(_) {}
}


function selectRecipientById(recipientId) {
  selectedRecipient = recipients.find(r => r.id == recipientId);
  renderRecipientSelectionList();
  if (recipients.length > 0) {
    document.getElementById('backToRecipientsBtn').classList.remove('hidden');
  }
}


function renderRecipientGiftStatus(recipientId) {
  const container = document.getElementById('recipientGiftStatus');
  if (!container) return;
  const giftData = recipientGifts[recipientId];
  if (!giftData) { container.innerHTML = ''; return; }

  const g = giftData.gift || {}; // { title, price, image, format, ... }
  const priceHtml = g.price ? ` - ${formatCurrency(g.price)}` : '';
  const imgHtml = g.image
    ? `<div class="gift-image" style="width:120px;height:120px;margin-right:12px;"><img src="${g.image}" alt="${g.title}"></div>`
    : '';

  container.innerHTML = `
    <div style="display:flex;align-items:center;background:#e8f5e9;padding:10px;border-radius:4px;">
      ${imgHtml}
      <div style="flex:1;">
        <strong>Gift selected:</strong> ${g.title || ''}${priceHtml}
        ${g.format ? `<div>Format: ${g.format}</div>` : ''}
        <div id="recipient-gift-action-btn-container" style="margin-top:6px;">
          <button class="btn btn-secondary" onclick="editRecipientGift()" style="padding:6px 12px;font-size:12px;">Edit Gift</button>
          <button class="btn btn-secondary" onclick="removeRecipientGift(${recipientId})" style="padding:6px 12px;font-size:12px;margin-left:6px;">Remove Gift</button>
        </div>
      </div>
    </div>
  `;
  try { ensureCopyButtons(); } catch(_) {}

}

// ---- Step 4 gate: only when all gifts are set ----
function allRecipientsGiftsSet() {
  return Array.isArray(recipients) && recipients.length > 0 &&
         recipients.every(r => !!recipientGifts[r.id]?.gift);
}

function onNextToReviewClick() {
  if (!allRecipientsGiftsSet()) {
    showHtmlAlert('Please assign a gift to every recipient before continuing.');
    return;
  }
  showStep4();
}

// Add this helper function to check if a recipient is a placeholder
function isPlaceholderRecipient(recipient) {
    return recipient && (
        recipient.isPlaceholder === true ||
        recipient.name === 'Unassigned Gift' ||
        recipient.email === 'skip@example.com'
    );
}

/**
 * Ensure the NEXT button exists next to #backToRecipientsBtn and reflect enabled/disabled state.
 * Call this after (re-)rendering the recipients list or whenever gifts change.
 */
function ensureNextButton() {
  const backBtn = document.getElementById('backToRecipientsBtn');
  if (!backBtn) return;

  let nextBtn = document.getElementById('nextToReviewBtn');
  if (!nextBtn) {
    nextBtn = document.createElement('button');
    nextBtn.id = 'nextToReviewBtn';
    nextBtn.className = 'btn btn-primary';
    nextBtn.textContent = 'NEXT';
    nextBtn.style.marginLeft = '8px';
    nextBtn.addEventListener('click', onNextToReviewClick);
    backBtn.parentNode.insertBefore(nextBtn, backBtn.nextSibling);
  }

  // Enable only when all recipients have a gift
  const ok = allRecipientsGiftsSet();
  nextBtn.disabled = !ok;

  // Mirror visibility with Back button
  const backHidden = backBtn.classList.contains('hidden');
  nextBtn.classList.toggle('hidden', backHidden);
}


function editRecipientGift(recipientId) {
  const rId = recipientId || (selectedRecipient ? selectedRecipient.id : null);
  if (!rId || !recipientGifts[rId]) {
    showHtmlAlert('No gift found to edit for this recipient yet.');
    return;
  }
  // ensure selectedRecipient is the one we're editing
  selectedRecipient = recipients.find(r => r.id === rId) || selectedRecipient;

  const giftData = recipientGifts[rId];
  selectedGift = giftData.gift;

  showStep2();
}

function removeRecipientGift(recipientId) {
  showHtmlConfirm('Are you sure you want to remove this gift?', () => {
    delete recipientGifts[recipientId];
    renderRecipientSelectionList();
    renderRecipientGiftStatus(recipientId);
    try { ensureNextButton(); } catch(_) {}
  });
}

function selectGiftForRecipient(recipientId) {
  selectedRecipient = recipients.find(r => r.id == recipientId) || null;
  selectedGift = null; // start fresh
  if (!selectedRecipient) {
    showHtmlAlert('Please select a valid recipient first.');
    return;
  }
  showStep2();
}

function showStep2() {
    document.getElementById('step2').classList.remove('hidden');
    document.getElementById('step1-progress').classList.add('completed');
    document.getElementById('step2-progress').classList.add('active');
    
    // If editing an existing gift, maintain the selection
    if (recipientGifts[selectedRecipient.id]) {
        selectedGift = recipientGifts[selectedRecipient.id].gift;
    }
    
    renderGiftCarousel();
}

function renderGiftCarousel() {
  const carousel = document.getElementById('giftCarousel');
  const container = document.getElementById('giftCarouselContainer');
  const createContainer = document.getElementById('createGiftContainer');
  
  carousel.innerHTML = '';

  // Handle empty gifts array - adjust layout
  if (!gifts || gifts.length === 0) {
    // Hide the carousel and make create container full width
    carousel.style.display = 'none';
    if (container) {
      container.style.justifyContent = 'center';
    }
    if (createContainer) {
      createContainer.style.width = '100%';
      createContainer.style.display = 'flex';
      createContainer.style.justifyContent = 'center';
    }
  } else {
    // Show carousel and reset layout
    carousel.style.display = 'flex';
    if (container) {
      container.style.justifyContent = 'flex-start';
    }
    if (createContainer) {
      createContainer.style.width = 'auto';
      createContainer.style.display = 'block';
      createContainer.style.justifyContent = 'initial';
    }

    gifts.forEach(gift => {
      const giftCard = document.createElement('div');
      giftCard.className = `gift-card ${gift.type === 'saved' ? 'saved' : ''}`;

      // Highlight currently selected gift
      if (selectedGift && selectedGift.id === gift.id) {
        giftCard.classList.add('selected');
      }

      giftCard.onclick = (e) => {
        if (!e.target.classList.contains('remove-btn')) {
          selectGift(gift, giftCard);
        }
      };

      // Defensive guard: image may be undefined/non-string
      const imgSrc = (typeof gift.image === 'string') ? gift.image : '';
      let giftImageHTML =
        imgSrc && imgSrc.startsWith('http')
          ? `<div class="gift-image"><img src="${imgSrc}" alt="${gift.title}"></div>`
          : (imgSrc
              ? `<div class="gift-image">${imgSrc}</div>`
              : `<div class="gift-image placeholder" title="No image">GC</div>`);

      let priceDisplay = `<div class="gift-price">${formatCurrency(gift.price)}</div>`;
      if (gift.packaging_price > 0 || gift.shipping_price > 0) {
        priceDisplay += `<div class="price-breakdown">`;
        if (gift.basePrice)               priceDisplay += `<span class="price-breakdown-base">Gift: ${formatCurrency(gift.basePrice)}</span>`;
        if (gift.packaging_price > 0)     priceDisplay += `<span class="price-breakdown-format"> | Format: ${formatCurrency(gift.packaging_price)}</span>`;
        if (gift.shipping_price > 0)      priceDisplay += `<span class="price-breakdown-shipping"> | Ship: ${formatCurrency(gift.shipping_price)}</span>`;
        priceDisplay += `</div>`;
      }

      giftCard.innerHTML = `
        ${giftImageHTML}
        <div class="gift-title">${gift.title}</div>
        ${priceDisplay}
        <button class="remove-btn" onclick="removeGift(event, ${gift.id})" title="Remove gift"><i class="fa fa-trash"></i></button>
      `;
      carousel.appendChild(giftCard);
    });
  }
}

function removeGift(event, giftId) {
    event.stopPropagation();
    
    showHtmlConfirm('Are you sure you want to remove this gift?', () => {
        // Clear selection if removing the selected gift
        if (selectedGift && selectedGift.id === giftId) {
            selectedGift = null;
        }
        
        gifts = gifts.filter(g => g.id !== giftId);
        renderGiftCarousel();
    });
}

function openGiftModal() {
    document.getElementById('giftModal').classList.remove('hidden');
    document.getElementById('giftLabel').value = '';
    document.getElementById('labelError').style.display = 'none';
    showGiftCategories();
}

function validateGiftLabel() {
    const label = document.getElementById('giftLabel').value.trim();
    const labelError = document.getElementById('labelError');
    
    if (label) {
        // Check if label already exists in gifts array
        const exists = gifts.some(gift => gift.title.toLowerCase() === label.toLowerCase());
        
        if (exists) {
            labelError.style.display = 'block';
            return false;
        } else {
            labelError.style.display = 'none';
            return true;
        }
    }
    
    labelError.style.display = 'none';
    return false;
}

function closeModal() {
    document.getElementById('giftModal').classList.add('hidden');
}

function showGiftCategories() {
    document.getElementById('configStep1').classList.add('active');
    document.getElementById('configStep2').classList.remove('active');
    document.getElementById('configStep3').classList.remove('active');
    
    let categoriesHTML = '<div class="gift-options">';
    
    Object.keys(GIFT_FORMAT_CONFIG).forEach(category => {
        const config = GIFT_FORMAT_CONFIG[category];
        const formats = config.formats.map(f => f.name).join(' or ');
        const personalisation = config.personalisation.enabled 
            ? config.personalisation.features.join(' + ')
            : 'N/A';
        const image = config.image;
        
        categoriesHTML += `
            <div class="gift-option" onclick="selectGiftCategory('${category}')">
                <h3 style="line-height: 1.5em;height: 3em;overflow: hidden; ">${category}</h3>
                <div class="gift-image"><img src="${image}" alt="${category}"></div>
                <p>Format: ${formats}</p>
                <p>Personalisation: ${personalisation}</p>
            </div>
        `;
    });
    
    categoriesHTML += '</div>';
    document.getElementById('modalContent').innerHTML = categoriesHTML;
}

function selectGiftCategory(category) {
    const label = document.getElementById('giftLabel').value.trim();
    
    if (!label) {
        showHtmlAlert('Please enter a name for your gift');
        return;
    }
    
    if (!validateGiftLabel()) {
        showHtmlAlert('This name is already used. Please choose a different one.');
        return;
    }
    
    // Store the category and label temporarily
    window.tempGiftConfig = { category, label };
    
    document.getElementById('configStep1').classList.remove('active');
    document.getElementById('configStep2').classList.add('active');
    
    if (category === 'Gift Cards') {
        // add class "gift-card" to the modal (to make it wider) 
        document.getElementById('modalContentContainer').classList.add("gift-card");

        // Show the gift card selection interface
        showGiftCardSelection();
    } else {
        // remove class "gift-card" from the modal
        document.getElementById('modalContentContainer').classList.remove("gift-card");

        // Show budget/gift options for other categories
        showBudgetOptions(category);
    }
}

function showGiftCardSelection() {
    const fees = { premium_0525: 10, advantage_0825: 10, signature_0825: 15 };
    const fee = fees[window.customerStatus] ?? 25;

    const activationLabel =
      fee
        ? `+${formatCurrency(25)} activation fees`
        : `+<s>${formatCurrency(25)}</s> ${formatCurrency(fee)} activation fees for Premium`;

    document.getElementById('modalContent').innerHTML = `
        <div class="gift-card-category-container">
            <div class="order-guided-form-swap-gift-card-grid">
                <!-- Column 1 - Banner + Carousel -->
                <div class="grid-div1">
                    <img class="banner" src="https://cdn.shopify.com/s/files/1/0478/1221/4947/files/2024_Christmas_Landing_page_7.jpg?v=1724997380" alt="Gift Card hero banner">
                    <div id="swap-card-carousel" class="carousel"></div>
                </div>
                
                <!-- Column 2 - Price Form -->
                <div class="grid-div2">
                    <div class="b2b-gift-card-price-form-container">
                        <fieldset class="js product-form__input">
                            <legend class="form__label"> ${activationLabel}  </legend>
                            <input type="radio" id="price-btn-1" name="giftCardPrice" value="50"><label for="price-btn-1">${formatCurrency(50)}</label>
                            <input type="radio" id="price-btn-3" name="giftCardPrice" value="100"><label for="price-btn-3">${formatCurrency(100)}</label>
                            <input type="radio" id="price-btn-4" name="giftCardPrice" value="150"><label for="price-btn-4">${formatCurrency(150)}</label>
                            <input type="radio" id="price-btn-5" name="giftCardPrice" value="200"><label for="price-btn-5">${formatCurrency(200)}</label>
                            <input type="radio" id="price-btn-6" name="giftCardPrice" value="250"><label for="price-btn-6">${formatCurrency(250)}</label>
                            <input type="radio" id="price-btn-7" name="giftCardPrice" value="300"><label for="price-btn-7">${formatCurrency(300)}</label>
                            <input type="radio" id="price-btn-8" name="giftCardPrice" value="400"><label for="price-btn-8">${formatCurrency(400)}</label>
                            <input type="radio" id="price-btn-9" name="giftCardPrice" value="500"><label for="price-btn-9">${formatCurrency(500)}</label>
                            <input type="radio" id="price-btn-10" name="giftCardPrice" value="1000"><label for="price-btn-10">${formatCurrency(1000)}</label>
                            <input type="radio" id="price-btn-11" name="giftCardPrice" value="2000"><label for="price-btn-11">${formatCurrency(2000)}</label>
                            <input type="radio" id="price-btn-12" name="giftCardPrice" value="3000"><label for="price-btn-12">${formatCurrency(3000)}</label>
                        </fieldset>
                        <button class="btn btn-primary gift-card-continue-btn" onclick="selectGiftCardPrice()" disabled>Continue</button>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    // Initialize gift card carousel
    initializeGiftCardCarousel();
    
    // Add event listeners for price selection
    document.querySelectorAll('input[name="giftCardPrice"]').forEach(radio => {
        radio.addEventListener('change', function() {
            document.querySelector('.gift-card-continue-btn').disabled = false;
        });
    });
}

async function initializeGiftCardCarousel() {
    const carousel = document.getElementById('swap-card-carousel');
    if (!carousel) return;
    
    carousel.innerHTML = '';
    
    // Ensure gift card slides are loaded
    if (giftCardSlides.length === 0) {
        await fetchGiftCardSlides();
    }
    
    giftCardSlides.forEach(({url, image, title, state}) => {
        const cell = document.createElement('div');
        cell.className = 'carousel-cell';
        cell.innerHTML = `
            <a href="${url}?goal=showcase" target="_blank">
              <img 
                src="${image}"
                alt="${title}"
                style="margin:8px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1),0 0 30px rgba(0, 0, 0, 0.05);">
            </a>
            <div class="caption">${title}</div>
            <div class="caption">${state}</div>
        `;
        carousel.appendChild(cell);
    });
    
    // Initialize Flickity after a short delay to ensure DOM is ready
    setTimeout(() => {
        if (window.Flickity) {
            // Destroy any existing instance first
            const existingFlkty = Flickity.data(carousel);
            if (existingFlkty) {
                existingFlkty.destroy();
            }
            
            const flkty = new Flickity('#swap-card-carousel', {
                cellAlign: 'left',
                contain: true,
                wrapAround: false,  // Changed from true to prevent glitches
                pageDots: false,
                prevNextButtons: true,
                percentPosition: false,  // Use pixel positioning
                adaptiveHeight: false,
                initialIndex: 0,
                setGallerySize: true,
                resize: true,
                imagesLoaded: true,
                draggable: true,
                friction: 0.28,
                selectedAttraction: 0.025
            });

            // Force resize after images load
            setTimeout(() => {
                flkty.resize();
                flkty.reposition();
            }, 500);
        }
    }, 350);
}

function selectGiftCardPrice() {
    const selectedPrice = document.querySelector('input[name="giftCardPrice"]:checked');
    if (!selectedPrice) {
        showHtmlAlert('Please select a price first');
        return;
    }
    
    const price = parseInt(selectedPrice.value);
    window.tempGiftConfig.basePrice = price;
    window.tempGiftConfig.price = price;
    const fees = { premium_0525: 10, advantage_0825: 10, signature_0825: 15 };
    const fee = fees[window.customerStatus] ?? 25;
    window.tempGiftConfig.activationPrice = fee;
    window.tempGiftConfig.giftHandle = "we-wander-swap-gift-card";
    window.tempGiftConfig.description = "Gift Card";
    
    // Show format selection for gift cards
    showFormatSelection();
}

function showBudgetOptions(category) {
  // Home Hampers: keep existing grid behaviour
  if (category !== 'Experience Collections') {
    let content = '<div class="gift-options">';
    let variants = [];

    if (category === 'Home Hampers') {
      variants = homeHamperVariants;
    }

    variants.forEach(variant => {
      const variantImageHTML = variant.image && variant.image.startsWith('http')
        ? `<div class="gift-image"><img src="${variant.image}" alt="${variant.title}"></div>`
        : `<div class="gift-image">${variant.image || ''}</div>`;

      const variantDescription = variant.description
        ? `<div class="gift-description">${variant.description}</div>`
        : '';

      content += `
        <div class="gift-option" onclick="selectBudgetOption(${variant.price}, '${variant.title.replace(/'/g, "\\'")}', '${variant.handle || ''}', '${variant.image || ''}')">
          ${variantImageHTML}
          <h3>${variant.title}</h3>
          <p>${formatCurrency(variant.price)}</p>
          ${variantDescription}
        </div>
      `;
    });

    content += '</div>';
    document.getElementById('modalContent').innerHTML = content;
    return;
  }

  // Experience Collections: render per category, each as a carousel
  const variants = experienceCollectionVariants || [];
  // Build a map: category -> [variants]
  const byCategory = {};
  variants.forEach(v => {
    const cats = String(v.Categories || 'Other')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    cats.forEach(cat => {
      if (!byCategory[cat]) byCategory[cat] = [];
      byCategory[cat].push(v);
    });
  });

  // Prefer to show "Most Popular" first if present
  const orderedCategories = Object.keys(byCategory).sort((a, b) => {
    if (a === 'Most Popular') return -1;
    if (b === 'Most Popular') return 1;
    return a.localeCompare(b);
  });

  let html = '';
  const carouselIds = [];

  orderedCategories.forEach((cat, idx) => {
    const id = `exp-carousel-${Date.now()}-${idx}`;
    carouselIds.push(id);

    // Build carousel cells as a string first
    const cells = byCategory[cat].map(variant => {
      const variantImageHTML = variant.image && variant.image.startsWith('http')
        ? `<div class="gift-image"><img src="${variant.image}" alt="${variant.title}"></div>`
        : `<div class="gift-image">${variant.image || ''}</div>`;

      const variantDescription = variant.description
        ? `<div class="gift-description">${variant.description.replace(/<\/?div[^>]*>/g, '')}</div>`
        : '';

      return `
        <div class="carousel-cell">
          <div class="gift-option"
               onclick="selectBudgetOption(${variant.price}, '${variant.title.replace(/'/g, "\\'")}', '${variant.handle}', '${variant.image || ''}')">
            ${variantImageHTML}
            <h3>${variant.title}</h3>
            <p>${formatCurrency(variant.price)}</p>
            ${variantDescription}
          </div>
        </div>
      `;
    }).join('');

    html += `
      <section class="experience-category">
        <h3 class="experience-category-title">${cat}</h3>
        <div id="${id}" class="carousel experience-carousel">
          ${cells}
        </div>
      </section>
    `;
  });

  document.getElementById('modalContent').innerHTML = html;

  // Init Flickity on each category carousel with proper settings
  setTimeout(() => {
    if (window.Flickity) {
      carouselIds.forEach(id => {
        const carousel = document.getElementById(id);
        if (carousel) {
          // Destroy any existing Flickity instance first
          const flkty = Flickity.data(carousel);
          if (flkty) {
            flkty.destroy();
          }
          
          // Create new instance with proper settings
          new Flickity(carousel, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,  // Changed from true to false to prevent wrapping issues
            pageDots: true,
            prevNextButtons: true,
            groupCells: false,
            percentPosition: false,  // Use pixel positioning
            adaptiveHeight: false,
            initialIndex: 0,
            setGallerySize: true,
            resize: true,
            lazyLoad: false,  // Disable lazy loading to prevent rendering issues
            imagesLoaded: true,  // Wait for images to load
            draggable: true,
            friction: 0.28,
            selectedAttraction: 0.025
          });
        }
      });
      
      // Force a resize after a short delay to ensure proper rendering
      setTimeout(() => {
        carouselIds.forEach(id => {
          const carousel = document.getElementById(id);
          if (carousel) {
            const flkty = Flickity.data(carousel);
            if (flkty) {
              flkty.resize();
              flkty.reposition();
            }
          }
        });
      }, 300);
    }
  }, 100);
}

function selectBudgetOption(price, title, handle, image) {
    window.tempGiftConfig.basePrice = price;
    window.tempGiftConfig.price = price; // Will be updated with format costs
    window.tempGiftConfig.description = title;
    window.tempGiftConfig.giftHandle = handle;
    window.tempGiftConfig.image = image;
    
    const categoryConfig = GIFT_FORMAT_CONFIG[window.tempGiftConfig.category];
    
    if (categoryConfig.formats.length === 1) {
        // Only one format available, auto-select it
        const format = categoryConfig.formats[0];
        window.tempGiftConfig.format = format.name;
        window.tempGiftConfig.packaging_price = format.packaging_price;

        const shippingFees = { premium_0525: 0, advantage_0825: 0, signature_0825: 0, essence_0825: 0};
        window.tempGiftConfig.shipping_price = shippingFees[window.customerStatus] ?? format.shipping_price;
        window.tempGiftConfig.price = window.tempGiftConfig.basePrice + format.packaging_price + window.tempGiftConfig.shipping_price;
        createNewGift();
    } else {
        // Multiple formats available, show selection
        showFormatSelection();
    }
}

function selectGiftFromModal(giftId, category) {
    selectedGift = gifts.find(g => g.id === giftId);
    
    if (category === 'Home Hampers') {
        closeModal();
        showStep3();
    } else {
        showFormatSelection();
    }
}

function showFormatSelection() {
  document.getElementById('configStep2').classList.remove('active');
  document.getElementById('configStep3').classList.add('active');

  const categoryConfig = GIFT_FORMAT_CONFIG[window.tempGiftConfig.category];
  let content = '<div class="gift-options">';

  categoryConfig.formats.forEach(format => {
    const shippingFeeStatuses = { premium_0525: 0, advantage_0825: 0, signature_0825: 0, essence_0825: 0};
    const shippingPrice = shippingFeeStatuses[window.customerStatus] ?? format.shipping_price;
    const totalFormatCost = (format.packaging_price || 0) + (shippingPrice || 0);
    const displayPrice = (window.tempGiftConfig.basePrice || 0) + (format.packaging_price || 0) + (window.tempGiftConfig.activationPrice ? window.tempGiftConfig.activationPrice : 0);
    const totalPrice = (window.tempGiftConfig.basePrice || 0)
                     + totalFormatCost
                     + (window.tempGiftConfig.activationPrice ? window.tempGiftConfig.activationPrice : 0);

    // Safe values for inline attribute usage
    const fNameRaw = String(format.name || '');
    const fName    = fNameRaw.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
    const fImgRaw  = (typeof format.image === 'string') ? format.image : '';
    const fImg     = fImgRaw.replace(/\\/g, '\\\\').replace(/'/g, "\\'");

    const formatImageHTML =
      fImgRaw && fImgRaw.startsWith('http')
        ? `<div class="gift-image"><img src="${fImgRaw}" alt="${fNameRaw}"></div>`
        : `<div class="gift-image">${fImgRaw || ''}</div>`;

    content += `
      <div class="gift-option"
           onclick="selectFormat('${fName}', ${format.packaging_price || 0}, ${shippingPrice || 0}, '${fImg}')">
        ${formatImageHTML}
        <h3>${formatCurrency(window.tempGiftConfig.basePrice)} '${window.tempGiftConfig.description}'</h3>
        <h3>${fNameRaw}</h3>
        <p>${format.description || ''}</p>
        <div class="format-price">
          <strong>Total: ${formatCurrency(displayPrice)}</strong><br>
          ${format.packaging_price > 0 ? `Packaging: +${formatCurrency(format.packaging_price)}<br>` : ''}
          ${shippingPrice > 0 ? `<!-- Shipping: +${formatCurrency(shippingPrice)} -->` : ''}
          ${window.tempGiftConfig.activationPrice > 0 ? `Card Activation: +${formatCurrency(window.tempGiftConfig.activationPrice)}`: ''}
        </div>
      </div>
    `;
  });

  content += '</div>';
  document.getElementById('modalContent').innerHTML = content;
}

function selectFormat(format, packagingPrice, shippingPrice, formatImage) {
  window.tempGiftConfig.format          = format;
  window.tempGiftConfig.packaging_price = packagingPrice || 0;
  window.tempGiftConfig.shipping_price  = shippingPrice  || 0;
  window.tempGiftConfig.price           = (window.tempGiftConfig.basePrice || 0)
                                        + (packagingPrice || 0)
                                        + (shippingPrice  || 0);

  // Ensure an image is present (covers Gift Card → Digital path)
  if (!window.tempGiftConfig.image) {
    window.tempGiftConfig.image = formatImage || '';
  }

  // For Gift Cards, synthesize the SKU now
  if (window.tempGiftConfig.category === 'Gift Cards') {
    const formatPrefix = (format || '').trim().charAt(0).toUpperCase() || 'D';
    window.tempGiftConfig.sku = `WEWANDER_SWAPGIFTCARD_${formatPrefix}_${window.tempGiftConfig.basePrice}`;
    // You already set giftHandle in selectGiftCardPrice: "we-wander-swap-gift-card"
  }

  createNewGift();
}

function createNewGift() {

    const category = window?.tempGiftConfig?.category;
    const defaultFormatByCategory = {
      'Gift Cards': 'Card',
      'Experience Collections': 'Portfolio',
      'Home Hampers': 'hamper pack',
    };

    if (isChristmasBlockActive() && !isAllowedGift(window.tempGiftConfig)) {
      showHtmlAlert(
        "🎄 Christmas Break Notice\n\n" +
        "Only Digital Experience Collections are available to order during this period.\n"
      );
      return;
    }

    const newGift = {
        id: Date.now(),
        title: window.tempGiftConfig.label,
        type: 'custom',
        basePrice: window.tempGiftConfig.basePrice,
        price: window.tempGiftConfig.price,
        giftHandle: window.tempGiftConfig.giftHandle,
        sku: window.tempGiftConfig.sku,
        category: window.tempGiftConfig.category,
        format: (window?.tempGiftConfig?.format) ?? (defaultFormatByCategory[category] ?? ''),
        packaging_price: window.tempGiftConfig.packaging_price || 0,
        shipping_price: window.tempGiftConfig.shipping_price || 0,
        description: window.tempGiftConfig.description,
        // image: `Custom ${window.tempGiftConfig.category}`,
        image: window.tempGiftConfig.image || '',
        native: false
    };
    
    // Add the new gift to the gifts array
    gifts.unshift(newGift);
    
    // Select the newly created gift
    selectedGift = newGift;
    
    // Close modal and update carousel
    closeModal();
    renderGiftCarousel();
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    
    // Proceed to personalization after a small delay for visual feedback
    setTimeout(() => {
        showStep3();
    }, 300);
}

function selectGift(gift, element) {

    if (isChristmasBlockActive() && !isAllowedGift(gift)) {
      alert(
        "🎄 Christmas Break Notice\n\n" +
        "Only Digital Experience Collections are available to order during this period.\n"
      );
      return;
    }

    // Remove selected class from all cards
    document.querySelectorAll('.gift-card').forEach(card => {
        card.classList.remove('selected');
    });
    
    // Add selected class to clicked card
    if (element) {
        element.classList.add('selected');
    }
    
    selectedGift = gift;
    
    // Small delay for visual feedback before proceeding
    setTimeout(() => {
        showStep3();
    }, 300);
}

function showStep3() {
    document.getElementById('step3').classList.remove('hidden');
    document.getElementById('step2-progress').classList.add('completed');
    document.getElementById('step3-progress').classList.add('active');
    
    // Reset upload area
    document.getElementById('uploadContent').innerHTML = '<p>Click to upload image</p>';
    document.getElementById('uploadArea').classList.remove('has-content');
    window.currentImageData = null;
    
    // Pre-fill if editing existing gift
    if (recipientGifts[selectedRecipient.id]) {
        const existing = recipientGifts[selectedRecipient.id].personalisation;
        if (existing) {
            document.getElementById('greetingMessage').value = existing.greetingMessage || '';
            document.getElementById('personalMessage').value = existing.personalMessage || '';
            
            // Pre-load existing image
            if (existing.coverImage) {
                window.currentImageData = existing.coverImage;
                const uploadContent = document.getElementById('uploadContent');
                document.getElementById('uploadArea').classList.add('has-content');
                
                // Use serverUrl for preview (fallback to dataUrl for backward compatibility)
                const imageSource = existing.coverImage.serverUrl || existing.coverImage.dataUrl;
                
                if (existing.coverImage.fileType.startsWith('image/')) {
                    uploadContent.innerHTML = `
                        <div class="upload-preview">
                            <img src="${imageSource}" alt="Cover image preview">
                            <button class="remove-image" onclick="removeImage(event)" title="Remove image">×</button>
                            <div class="file-info">${existing.coverImage.fileName}</div>
                        </div>
                    `;
                } else {
                    uploadContent.innerHTML = `
                        <div class="upload-preview">
                            <div style="padding: 20px;">
                                <p style="font-size: 48px; margin-bottom: 10px;">📄</p>
                                <p style="font-weight: 600;">${existing.coverImage.fileName}</p>
                            </div>
                            <button class="remove-image" onclick="removeImage(event)" title="Remove file">×</button>
                        </div>
                    `;
                }
            }
        }
    } else {
        // Clear form for new gift
        document.getElementById('greetingMessage').value = '';
        document.getElementById('personalMessage').value = '';
    }
    // try { injectStep3Carousel(); } catch (e) { console.warn('Step3 carousel inject error', e); }
    try { injectStep3ToggleImageViewer(); } catch (e) { console.warn('Step3 Toggle Image Viewer inject error', e); }
}

document.addEventListener('DOMContentLoaded', () => {
    // Initialize gift card slides on page load
    fetchGiftCardSlides();
    
    document.addEventListener('datechange', event => {
        const picker = /** @type {HTMLElement} */(event.target);
        if (!picker.id.startsWith('datePicker-')) return;
        const recipientId = picker.id.split('-')[1];
        const eventDetail = event.detail;
        const ship = recipientGifts[recipientId]?.shipping;
        if (ship) {
            // Only update date/fees if method is 'schedule'
            // Prevents date picker from setting fees when 'Standard shipping' is selected
            if (ship.method === 'schedule') {
                ship.date = eventDetail.date;
                ship.express_fee = eventDetail.hasExpressFee ? eventDetail.fee : 0;
                ship.variant_id = eventDetail.feeProductVariantId;
            }
        }
    });
});

/**
 * Per-recipient: Select delivery method ('now' or 'schedule')
 */
function selectDelivery(recipientId, method, element) {
    document
        .getElementById(`delivery-options-method-${recipientId}`)
        .querySelectorAll('.delivery-option')
        .forEach(opt => opt.classList.remove('selected'));
    element.classList.add('selected');

    recipientGifts[recipientId].shipping.method = method;
    if (method === 'schedule') {
        recipientGifts[recipientId].shipping.date =
            document.getElementById(`datePicker-${recipientId}`).value;
    } else {
        // Clear date, express fee, and variant when selecting standard shipping
        recipientGifts[recipientId].shipping.date = null;
        recipientGifts[recipientId].shipping.express_fee = 0;
        recipientGifts[recipientId].shipping.variant_id = null;
    }
    
    // Trigger autosave to persist the changes
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
}

/**
 * Render Step 4: one review + shipping block **per** recipient
 */
// Update the showStep4 function to include recipient info form for digital + placeholder
function showStep4() {
  document.getElementById('step4').classList.remove('hidden');
  document.getElementById('step3-progress').classList.add('completed');
  document.getElementById('step4-progress').classList.add('active');
  window.location = '#step4';

  const reviewContent = document.getElementById('reviewContent');
  let html = `
    <div class="review-section">
      <h3>Order: ${document.getElementById('orderName').value || 'Untitled Order'}</h3>
      <p style="margin-bottom:20px;">
        ${Object.keys(recipientGifts).length} Recipient(s) |
        Total Gifts: ${Object.values(recipientGifts).length}
      </p>
  `;

  recipients.forEach((recipient, idx) => {
    const giftData = recipientGifts[recipient.id];
    if (giftData) {
      const isDigital = (giftData?.gift?.format || '').toLowerCase() === 'digital';
      const isPlaceholder = isPlaceholderRecipient(recipient);

      // Ensure shipping object
      giftData.shipping = giftData.shipping || { 
        method: 'now', 
        date: null, 
        destination: isDigital ? 'recipient' : 'office', 
        address: {} 
      };
      
      if (!giftData.shipping.destination) {
        giftData.shipping.destination = isDigital ? 'recipient' : 'office';
      }

      if (isDigital) {
        giftData.shipping.method = 'schedule';
        giftData.shipping.express_fee = 0;
        giftData.shipping.variant_id = null;
      }

      // CRITICAL: Clear express fees for standard shipping (method='now')
      // This prevents date picker initialization from setting unwanted fees
      if (giftData.shipping.method === 'now') {
        giftData.shipping.express_fee = 0;
        giftData.shipping.variant_id = null;
        giftData.shipping.date = null;
      }

      const p = giftData.personalisation || {};

      let imagePreview = '<div class="review-gift-image"></div>';
      if (p.coverImage) {
        const coverImage = p.coverImage;
        const imageSource = coverImage.serverUrl || coverImage.dataUrl; // Use serverUrl, fallback to dataUrl
        if (coverImage.fileType && coverImage.fileType.startsWith('image/')) {
          imagePreview = `<div class="review-gift-image" style="background-image:url('${imageSource}');background-size:cover;background-position:center;"></div>`;
        } else {
          imagePreview = `<div class="review-gift-image" style="display:flex;align-items:center;justify-content:center;font-size:36px;">📄</div>`;
        }
      }

      html += `
        <div class="review-recipient" id="recipient-${recipient.id}" style="margin-bottom:40px;">
          <h4 class="review-recipient-name">${recipient.name || 'Recipient'}</h4>
          <div class="review-gift-preview" style="display:flex;align-items:flex-start;">
            ${imagePreview}
            <div class="review-gift-info" style="flex:1;display:flex;justify-content:space-between;align-items:center;margin-left:20px;">
              <div>
                <h4>${giftData.gift.title}</h4>
                <p>Format: ${giftData.gift.format || 'Physical'}</p>
                <p><b>Total Price: ${formatCurrency(giftData.gift.price)}</b></p>
                ${giftData.gift.shipping_price ? `<p>Shipping: ${formatCurrency(giftData.gift.shipping_price)}</p>` : ``}
                ${p.greetingMessage ? `<p>Message: "${p.greetingMessage}"</p>` : ``}
                ${p.coverImage ? `<p>Cover File: ${p.coverImage.fileName}</p>` : ``}
              </div>
              <button class="btn btn-secondary" onclick="updateGift(${recipient.id})" style="padding:8px 16px;font-size:12px;">
                Update
              </button>
            </div>
          </div>

          ${isDigital && isPlaceholder ? `
          <!-- Required Recipient Information for Digital Gift -->
          <div class="recipient-info-form" style="margin-top:20px;padding:15px;background:#fff3cd;border-radius:4px;border:1px solid #ffc107;">
            <h3 style="margin-top:0;color:#856404;">⚠️ Recipient Information Required</h3>
            <p style="margin-bottom:15px;color:#856404;">Please provide the recipient's information for this digital gift delivery.</p>
            <form id="recipient-info-form-${recipient.id}">
              <div class="form-group">
                <label>Recipient Full Name *</label>
                <input type="text" 
                       id="recipient-name-${recipient.id}" 
                       required 
                       placeholder="Enter recipient's full name" 
                       value="${!isPlaceholder ? recipient.name : ''}"
                       data-required="true">
              </div>
              <div class="form-group">
                <label>Recipient Email *</label>
                <input type="email" 
                       id="recipient-email-${recipient.id}" 
                       required 
                       placeholder="recipient@email.com" 
                       value="${!isPlaceholder ? recipient.email : ''}"
                       data-required="true">
              </div>
            </form>
          </div>
          ` : ''}

          <!-- Delivery Method -->
          <div class="delivery-options" id="delivery-options-method-${recipient.id}" style="margin-top:20px;">
            ${
              isDigital
                ? `
                  <div class="delivery-option selected" onclick="selectDelivery(${recipient.id}, 'schedule', this)">
                    <h3>Schedule Send</h3>
                    <shipping-date-picker id="datePicker-${recipient.id}" value="${giftData.shipping.date || ''}" data-digital="1"></shipping-date-picker>
                  </div>
                `
                : `
                  <div class="delivery-option ${giftData.shipping.method==='now'?'selected':''}" onclick="selectDelivery(${recipient.id}, 'now', this)">
                    <h3>Standard shipping</h3>
                    <p>Dispatched within 3-4 business days</p>
                  </div>
                  <div class="delivery-option ${giftData.shipping.method==='schedule'?'selected':''}" onclick="selectDelivery(${recipient.id}, 'schedule', this)">
                    <h3>Schedule Send</h3>
                    <shipping-date-picker id="datePicker-${recipient.id}" value="${giftData.shipping.date || ''}"></shipping-date-picker>
                  </div>
                `
            }
          </div>

          ${!isPlaceholder ? `
          <!-- Destination (only show if not placeholder) -->
          <div class="delivery-options" id="delivery-options-dest-${recipient.id}" style="margin-top:20px;">
            <div class="delivery-option ${giftData.shipping.destination==='office'?'selected':''}" onclick="selectDestination(${recipient.id}, 'office', this)"><h3>To Office</h3></div>
            <div class="delivery-option ${giftData.shipping.destination==='recipient'?'selected':''}" onclick="selectDestination(${recipient.id}, 'recipient', this)"><h3>To Recipient</h3></div>
          </div>

          <!-- Address / Email form -->
          <div id="shippingAddressForm-${recipient.id}" 
               class="shipping-address-form ${(giftData.shipping.destination==='recipient') ? '' : 'hidden'}" 
               style="margin-top:20px;">
            ${
              isDigital
                ? `
                  <h3>Recipient Email Address</h3>
                  <form>
                    <div class="form-group">
                      <label>Email *</label>
                      <input type="email" 
                             id="email-${recipient.id}" 
                             required 
                             placeholder="recipient@email.com" 
                             value="${giftData.shipping.address.email || recipient.email || ''}">
                    </div>
                  </form>
                `
                : `
                  <h3>Shipping Address</h3>
                  <div class="po-box-warning">⚠️ We cannot ship to PO Box addresses. Please provide a street address.</div>
                  <form>
                    <div class="form-group"><label>Street Address *</label>
                      <input type="text" id="street-${recipient.id}" required placeholder="123 Main St" value="${giftData.shipping.address.line1 || ''}">
                    </div>
                    <div class="form-group"><label>Unit/Suite #</label>
                      <input type="text" id="unit-${recipient.id}" placeholder="Unit, suite, etc" value="${giftData.shipping.address.line2 || ''}">
                    </div>
                    <div class="form-group"><label>Suburb/City *</label>
                      <input type="text" id="suburb-${recipient.id}" required placeholder="Sydney" value="${giftData.shipping.address.suburb || ''}">
                    </div>
                    <div class="form-group"><label>State *</label>
                      <input type="text" id="state-${recipient.id}" required placeholder="NSW" value="${giftData.shipping.address.state || ''}">
                    </div>
                    <div class="form-group"><label>Postal Code *</label>
                      <input type="text" id="postcode-${recipient.id}" required placeholder="2000" value="${giftData.shipping.address.postcode || ''}">
                    </div>
                    <div class="form-group"><label>Country *</label>
                      <select id="country-${recipient.id}" required>
                        <option value="AU" ${giftData.shipping.address.country==='AU'?'selected':''}>Australia</option>
                        <option value="NZ" ${giftData.shipping.address.country==='NZ'?'selected':''}>New Zealand</option>
                      </select>
                    </div>
                  </form>
                `
            }
          </div>
          ` : ''}
        </div>
        ${idx < recipients.length - 1 ? '<hr class="review-divider" />' : ''}
      `;
    }
  });

  const total = Object.values(recipientGifts).reduce((sum, item) => sum + (item?.gift?.price || 0), 0);
  html += `<div style="text-align:right;margin-top:20px;font-size:18px;font-weight:600;">Total: ${formatCurrency(total)}</div></div>`;
  reviewContent.innerHTML = html;
  try { ensureCopyButtons(); } catch(_) {}
}


function updateGift(recipientId) {
    // Set flag to indicate we're updating from step 4
    isUpdatingFromStep4 = true;
    
    // Find the recipient and set as selected
    selectedRecipient = recipients.find(r => r.id === recipientId);
    
    // Get the existing gift data
    const existingGiftData = recipientGifts[recipientId];
    selectedGift = existingGiftData.gift;
    
    // Hide step 4 and show step 2 and 3
    document.getElementById('step4').classList.add('hidden');
    document.getElementById('step2').classList.remove('hidden');
    document.getElementById('step3').classList.remove('hidden');
    
    // Update progress indicators
    document.getElementById('step4-progress').classList.remove('active');
    document.getElementById('step3-progress').classList.add('active');
    
    // Render gift carousel with selected gift
    renderGiftCarousel();
    
    // Pre-fill personalisation form with existing data
    const personalisation = existingGiftData.personalisation;
    document.getElementById('greetingMessage').value = personalisation.greetingMessage || '';
    document.getElementById('personalMessage').value = personalisation.personalMessage || '';
    
    // Handle existing cover image
    if (personalisation.coverImage) {
        window.currentImageData = personalisation.coverImage;
        const uploadContent = document.getElementById('uploadContent');
        document.getElementById('uploadArea').classList.add('has-content');
        
        // Use serverUrl for preview (fallback to dataUrl for backward compatibility)
        const imageSource = personalisation.coverImage.serverUrl || personalisation.coverImage.dataUrl;
        
        if (personalisation.coverImage.fileType.startsWith('image/')) {
            uploadContent.innerHTML = `
                <div class="upload-preview">
                    <img src="${imageSource}" alt="Cover image preview">
                    <button class="remove-image" onclick="removeImage(event)" title="Remove image">×</button>
                    <div class="file-info">${personalisation.coverImage.fileName}</div>
                </div>
            `;
        } else {
            uploadContent.innerHTML = `
                <div class="upload-preview">
                    <div style="padding: 20px;">
                        <p style="font-size: 48px; margin-bottom: 10px;">📄</p>
                        <p style="font-weight: 600;">${personalisation.coverImage.fileName}</p>
                    </div>
                    <button class="remove-image" onclick="removeImage(event)" title="Remove file">×</button>
                </div>
            `;
        }
    } else {
        // Reset upload area if no existing image
        document.getElementById('uploadContent').innerHTML = '<p>Click to upload image</p>';
        document.getElementById('uploadArea').classList.remove('has-content');
        window.currentImageData = null;
    }
    
    // Scroll to step 3
    document.getElementById('step3').scrollIntoView({ behavior: 'smooth' });
}

function selectDelivery(recipientId, method, element) {
  const model = recipientGifts[recipientId] || (recipientGifts[recipientId] = {});
  const ship  = model.shipping || (model.shipping = { method:'now', date:null, destination:'office', address:{} });

  const isDigital = ((model?.gift?.format || '').toLowerCase() === 'digital');
  if (isDigital) method = 'schedule';

  // Update model
  ship.method = method;
  if (method === 'schedule') {
    const picker = document.getElementById(`datePicker-${recipientId}`);
    ship.date = picker ? picker.value : ship.date || null;
    // No express for Digital — keep zero/cleared below by the datechange handler too
  } else {
    ship.date = null;
  }

  // Update UI selection in this block
  const container = document.getElementById(`delivery-options-method-${recipientId}`);
  if (container) {
    container.querySelectorAll('.delivery-option').forEach(opt => opt.classList.remove('selected'));
    element.classList.add('selected');
  }
}

function selectDestination(recipientId, dest, element) {
  const ship = recipientGifts[recipientId].shipping || (recipientGifts[recipientId].shipping = { method:'now', date:null, destination:'office', address:{} });
  ship.destination = dest;

  const container = document.getElementById(`delivery-options-dest-${recipientId}`);
  container.querySelectorAll('.delivery-option').forEach(opt => opt.classList.remove('selected'));
  element.classList.add('selected');

  const addressForm = document.getElementById(`shippingAddressForm-${recipientId}`);
  const isDigital = ((recipientGifts[recipientId]?.gift?.format || '').toLowerCase() === 'digital');

  if (dest === 'recipient') {
    addressForm.classList.remove('hidden');
    if (isDigital) {
      // prefill email if missing
      const input = document.getElementById(`email-${recipientId}`);
      if (input && !input.value) {
        input.value = recipients.find(r => r.id === recipientId)?.email || '';
      }
    } else {
      // prefill physical address
      try {
        const sel = recipients.find(r => r.id === recipientId);
        const raw = sel?.address || '';
        const addr = australiaAddressParser.parseLocation(raw);
        document.getElementById(`street-${recipientId}`).value   = [addr.streetNumber, addr.streetName, addr.streetType].filter(Boolean).join(' ');
        document.getElementById(`unit-${recipientId}`).value     = addr.unitNumber || '';
        document.getElementById(`suburb-${recipientId}`).value   = addr.suburb   || '';
        document.getElementById(`state-${recipientId}`).value    = addr.state    || '';
        document.getElementById(`postcode-${recipientId}`).value = addr.postcode || '';
        document.getElementById(`country-${recipientId}`).value  = 'AU';
      } catch (err) {
        console.error('Address parsing failed', err);
      }
    }
  } else {
    addressForm.classList.add('hidden');
  }
}


function handleUploadClick(event) {
    // Only trigger file input if clicking on the empty area
    if (!window.currentImageData) {
        document.getElementById('coverImage').click();
    }
}

// Server URL for uploaded files
const URL_SERVER_FILES = 'https://we-wa.com.au/wp-content/uploads/personalisedSleeves/';

async function handleImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    // Show loading state
    const uploadContent = document.getElementById('uploadContent');
    uploadContent.innerHTML = '<p>Uploading image...</p>';
    
    try {
        // Generate unique filename
        const filename = Date.now() + '_' + file.name.replace(/[^a-zA-Z0-9.]/g, '_');
        const serverUrl = URL_SERVER_FILES + filename;
        
        // Upload file to server
        await _storeUploadFile(file, filename);
        
        // Read file for preview
        const reader = new FileReader();
        reader.onload = function(e) {
            // Check if file is an image
            if (file.type.startsWith('image/')) {
                uploadContent.innerHTML = `
                    <div class="upload-preview">
                        <img src="${e.target.result}" alt="Cover image preview">
                        <button class="remove-image" onclick="removeImage(event)" title="Remove image">×</button>
                        <div class="file-info">${file.name}</div>
                    </div>
                `;
            } else {
                // For non-image files, just show filename
                uploadContent.innerHTML = `
                    <div class="upload-preview">
                        <div style="padding: 20px;">
                            <p style="font-size: 48px; margin-bottom: 10px;">📄</p>
                            <p style="font-weight: 600;">${file.name}</p>
                            <p style="font-size: 12px; color: #666;">${(file.size / 1024).toFixed(2)} KB</p>
                        </div>
                        <button class="remove-image" onclick="removeImage(event)" title="Remove file">×</button>
                    </div>
                `;
            }
            
            // Store both the preview data and server URL
            window.currentImageData = {
                dataUrl: e.target.result,  // For preview display
                serverUrl: serverUrl,       // Server URL for cart
                fileName: file.name,
                fileType: file.type
            };
            
            // Add visual feedback
            document.getElementById('uploadArea').classList.add('has-content');
        };
        
        reader.readAsDataURL(file);
        
    } catch (error) {
        console.error('Upload failed:', error);
        uploadContent.innerHTML = '<p style="color: red;">Upload failed. Please try again.</p>';
        showHtmlAlert('Failed to upload image. Please try again.');
    }
}

function removeImage(event) {
    event.stopPropagation();
    document.getElementById('coverImage').value = '';
    document.getElementById('uploadContent').innerHTML = '<p>Click to upload image</p>';
    document.getElementById('uploadArea').classList.remove('has-content');
    window.currentImageData = null;
}

async function _saveDesign() {
  // Save into the per-recipient model
  if (!selectedRecipient || !selectedGift) {
    showHtmlAlert && showHtmlAlert('Please pick a recipient and a gift first.');
    return;
  }

  if (window.__giftDraft__) window.__giftDraft__.queueAutosave();

  const isDigital = ((selectedGift?.format || '').toLowerCase() === 'digital');
  
  recipientGifts[selectedRecipient.id] = {
    recipient: selectedRecipient,
    gift: selectedGift,
    personalisation: {
      greetingMessage: document.getElementById('greetingMessage').value,
      personalMessage: document.getElementById('personalMessage').value,
      coverImage: window.currentImageData || null
    },
    // Initialize shipping with proper defaults
    shipping: recipientGifts[selectedRecipient.id]?.shipping || {
      method: isDigital ? 'schedule' : 'now',
      date: null,
      destination: isDigital ? 'recipient' : 'office',
      address: {},
      express_fee: 0,
      variant_id: null
    }
  };

  // Save the updated gifts array to customer metafield
  try {
    let param = {
      "customerid": window.Shopify.customerId,
      "metafieldNamespace": "b2b",
      "metafieldKey": "presetGifts",
      "value": JSON.stringify(gifts),
      "type": "json",
      "bjson": 1,
      "timestamp": window.timestamp,
      "check": window.passpin
    };
    
    await $.ajax({
      type: "POST",
      url: 'https://www.we-wa.com.au/wp-json/shopify/v1/updateCustGivenMetafieldShopify',
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(param),
    });
  } catch (err) {
    console.warn("Failed to save gifts to metafield:", err);
    // Don't block the user flow if metafield save fails
  }

  // Refresh UI so "Select Gift" disappears and Edit/Copy/Remove show up
  try { renderRecipientSelectionList(); } catch(_) {}
  try { renderRecipientGiftStatus(selectedRecipient.id); } catch(_) {}
  try { ensureNextButton(); } catch(_) {} // keep NEXT gating synced
  try { ensurePasteButtons(); } catch(_) {} // optional: if you want paste hints to appear immediately
}


function saveDesign() {
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    // Save current design
    if (selectedRecipient && selectedGift) {
        // Save the gift and personalisation for this recipient
        _saveDesign();
        alert('Design saved successfully!');
    }
}

function saveAndContinue() {
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    // Save the gift and personalisation for this recipient
    _saveDesign();
    
    // Check if we're updating from step 4
    if (isUpdatingFromStep4) {
        // Reset the flag
        isUpdatingFromStep4 = false;
        
        // Return to step 4 after updating
        document.getElementById('step2').classList.add('hidden');
        document.getElementById('step3').classList.add('hidden');
        document.getElementById('step4').classList.remove('hidden');
        
        // Update progress indicators
        document.getElementById('step3-progress').classList.remove('active');
        document.getElementById('step3-progress').classList.add('completed');
        document.getElementById('step4-progress').classList.add('active');
        
        // Refresh the review content to show updated information
        showStep4();
        
        alert('Gift updated successfully!');
        return;
    }
    
    // Check if all recipients have gifts
    const allRecipientsHaveGifts = recipients.every(r => recipientGifts[r.id]);
    
    if (allRecipientsHaveGifts) {
        // All recipients have gifts, proceed to review
        showStep4();
    } else {
        // Return to recipients list to select next recipient
        showHtmlAlert('Gift saved for ' + selectedRecipient.name + '! Select the next recipient.');
        resetToRecipientsList();
    }
}
// Add this new function to handle going back to Step 1
function backToStep1() {
    // Hide all other steps
    document.getElementById('recipientsList').classList.add('hidden');
    document.getElementById('step2').classList.add('hidden');
    document.getElementById('step3').classList.add('hidden');
    document.getElementById('step4').classList.add('hidden');
    
    // Show step 1
    document.getElementById('step1').style.display = 'block';
    
    // Reset progress indicators
    document.getElementById('step1-progress').classList.add('active');
    document.getElementById('step1-progress').classList.remove('completed');
    document.getElementById('step2-progress').classList.remove('active', 'completed');
    document.getElementById('step3-progress').classList.remove('active', 'completed');
    document.getElementById('step4-progress').classList.remove('active', 'completed');
    
    // Clear selections but keep data
    selectedRecipient = null;
    selectedGift = null;
    window.currentImageData = null;

    // Update button visibility based on recipients
    if (recipients.length === 0) {
        document.getElementById('selectGiftsBtn').style.display = 'none';
        document.getElementById('skipRecipientsBtn').style.display = 'inline-block';
    } else {
        document.getElementById('selectGiftsBtn').style.display = 'inline-block';
        document.getElementById('skipRecipientsBtn').style.display = 'none';
    }

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
} 

function buildStep3CarouselHTML(category, formatName, fallbackImg, carouselId, sku="") {
  const imgs = getCompanyImagesForFormat(category, formatName, sku);
  const images = imgs.length ? imgs : (fallbackImg ? [fallbackImg] : []);
  if (!images.length) return '';

  return `
    <div class="step3-format-carousel-wrapper">
      <div id="${carouselId}" class="carousel step3-format-carousel">
        ${images.map(u => `
          <div class="carousel-cell">
            <div class="gift-image"><img src="${u}" alt="${formatName || 'Format'}"></div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

function buildStep3ToggleImageViewer(category, formatName, fallbackImg, containerId, sku) {
  const imgs = (getCompanyImagesForFormat(category, formatName, sku) || []).filter(Boolean);
  const images = imgs.length ? imgs : (fallbackImg ? [fallbackImg] : []);
  
  // Ensure we have at least 2 images (use placeholder for missing ones)
  const placeholderImg = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width=\'1200\' height=\'675\'><rect width=\'100%\' height=\'100%\' fill=\'%23f6f6f6\'/><text x=\'50%\' y=\'50%\' dominant-baseline=\'middle\' text-anchor=\'middle\' fill=\'%23999\' font-family=\'sans-serif\' font-size=\'28\'>No image</text></svg>';
  
  const frontImage = images[0] || placeholderImg;
  const backImage = images[1] || images[0] || placeholderImg;
  
  const sanitizedFormatName = formatName.toLowerCase()
    .replace(/[^a-z0-9-_]/g, '-')  // Replace non-alphanumeric chars with hyphens
    .replace(/-+/g, '-')            // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '');         // Remove leading/trailing hyphens
  
  if(sanitizedFormatName === "hamper-pack") {
    document.querySelectorAll('.personalisation-form .form-group').forEach(group => group.classList.add("hidden"));
  } else {
    document.querySelectorAll('.personalisation-form .form-group').forEach(group => group.classList.remove("hidden"));
  }

  return `
    <div class="step3-image-toggle-container ${sanitizedFormatName}" id="${containerId}">
      <div class="toggle-button-wrapper">
        <button class="toggle-btn active" data-side="front" onclick="toggleStep3Image('${containerId}', 'front')">
          Front
        </button>
        <button class="toggle-btn" data-side="back" onclick="toggleStep3Image('${containerId}', 'back')">
          Back
        </button>
      </div>
      <div class="toggle-image-display">
        <!-- Front view with arrows -->
        <div class="toggle-image-wrapper active" data-side="front">
          <img class="toggle-image" src="${frontImage}" alt="Front view">
          <img class="arrow-overlay cover-photo-arrow" src="https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Cover_Photo_Arrow.png?v=1755678895" alt="">
          <img class="arrow-overlay greeting-message-arrow" src="https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Greeting_Message_Arrow.png?v=1755678896" alt="">
        </div>
        
        <!-- Back view with arrows -->
        <div class="toggle-image-wrapper" data-side="back">
          <img class="toggle-image" src="${backImage}" alt="Back view">
          <img class="arrow-overlay agent-photo-arrow" src="https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Agent_photo_Arrow.png?v=1755678895" alt="">
          <img class="arrow-overlay personalised-message-arrow" src="https://cdn.shopify.com/s/files/1/0478/1221/4947/files/Personalised_Message_Arrow.png?v=1755678895" alt="">
        </div>
      </div>
    </div>
  `;
}

// Add the toggle function
window.toggleStep3Image = function(containerId, side) {
  const container = document.getElementById(containerId);
  if (!container) return;
  
  // Update button states
  container.querySelectorAll('.toggle-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.side === side);
  });
  
  // Update image wrapper visibility
  container.querySelectorAll('.toggle-image-wrapper').forEach(wrapper => {
    wrapper.classList.toggle('active', wrapper.dataset.side === side);
  });
};


// --- tiny helper: wait until an element appears under a root (timeout optional)
function waitForElementIn(root, selector, timeoutMs = 4000) {
  return new Promise(resolve => {
    const found = root.querySelector(selector);
    if (found) return resolve(found);

    const obs = new MutationObserver(() => {
      const el = root.querySelector(selector);
      if (el) { obs.disconnect(); clearTimeout(t); resolve(el); }
    });
    obs.observe(root, { childList: true, subtree: true });

    const t = setTimeout(() => { obs.disconnect(); resolve(null); }, timeoutMs);
  });
}

function getCompanyImagesForFormat(category, formatName, sku) {
  const src = window.companyImages || {};
  if (Array.isArray(src)) return src.filter(Boolean);

  const fmt = String(formatName || '').trim().toLowerCase();

  // Gift Cards → swap_* mapping
  if ((category || '').toLowerCase() === 'gift cards') {
    if (fmt.startsWith('card'))    return (src['swap_card']    || []).filter(Boolean);
    if (fmt.startsWith('digital')) return (src['swap_digital'] || []).filter(Boolean);
  }
  if ((category || '').toLowerCase() === 'home hampers') {
    const lsku = String(sku || '').trim().toLowerCase();
    if (fmt.startsWith('hamper'))    return (src[`${fmt} ${lsku}`]    || []).filter(Boolean);
  }
  // Others → plain key (e.g. "portfolio", "card & keys", "digital")
  return (src[fmt] || []).filter(Boolean);
}

// --- tiny helper: wait until an element appears under a root (timeout optional)
function waitForElementIn(root, selector, timeoutMs = 4000) {
  return new Promise(resolve => {
    const found = root.querySelector(selector);
    if (found) return resolve(found);

    const obs = new MutationObserver(() => {
      const el = root.querySelector(selector);
      if (el) { obs.disconnect(); clearTimeout(t); resolve(el); }
    });
    obs.observe(root, { childList: true, subtree: true });

    const t = setTimeout(() => { obs.disconnect(); resolve(null); }, timeoutMs);
  });
}

// existing helper you already have
// function getCompanyImagesForFormat(category, formatName, sku) { ... }

function buildStep3CarouselHTML(category, formatName, fallbackImg, carouselId, sku) {
  const imgs = (getCompanyImagesForFormat(category, formatName, sku) || []).filter(Boolean);
  const images = imgs.length ? imgs : (fallbackImg ? [fallbackImg] : []);
  // ALWAYS mount something so we know the injector worked
  const list = images.length ? images : [ 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width=\'1200\' height=\'675\'><rect width=\'100%\' height=\'100%\' fill=\'%23f6f6f6\'/><text x=\'50%\' y=\'50%\' dominant-baseline=\'middle\' text-anchor=\'middle\' fill=\'%23999\' font-family=\'sans-serif\' font-size=\'28\'>No image</text></svg>' ];

  return `
    <div class="step3-format-carousel-wrapper">
      <div id="${carouselId}" class="carousel step3-format-carousel">
        ${list.map(u => `
          <div class="carousel-cell">
            <div class="gift-image"><img src="${u}" alt="${formatName || 'Format'}"></div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

async function injectStep3Carousel() {
  const step3 = document.getElementById('step3');
  if (!step3) return;

  // Determine the gift being personalised right now
  const gift =
    (typeof selectedGift !== 'undefined' && selectedGift) ? selectedGift
    : (selectedRecipient && recipientGifts?.[selectedRecipient.id]?.gift) || null;

  const category = gift?.category || window.tempGiftConfig?.category || '';
  const format   = gift?.format   || window.tempGiftConfig?.format   || '';
  const fallback = gift?.image    || window.tempGiftConfig?.image    || '';
  const sku      = gift?.sku      || window.tempGiftConfig?.sku      || '';

  // Wait for the Liquid form node
  const persForm = await waitForElementIn(step3, '.personalisation-form', 5000);
  if (!persForm) return; // form never showed up

  const carouselId = 'step3-format-carousel';

  // Idempotent: remove old
  const existingWrapper = step3.querySelector(`#${carouselId}`)?.closest('.step3-format-carousel-wrapper');
  if (existingWrapper) {
    // Destroy Flickity instance if it exists
    const existingCarousel = document.getElementById(carouselId);
    if (existingCarousel) {
      const flkty = Flickity.data(existingCarousel);
      if (flkty) {
        flkty.destroy();
      }
    }
    existingWrapper.remove();
  }

  // Insert immediately BEFORE the form node
  persForm.insertAdjacentHTML('beforebegin', buildStep3CarouselHTML(category, format, fallback, carouselId, sku));

  // Init Flickity with improved settings
  const el = document.getElementById(carouselId);
  if (el && window.Flickity) {
    try {
      const flkty = new Flickity(el, {
        cellAlign: 'center',
        contain: true,  // Changed from false to true
        wrapAround: false,  // Changed from true to prevent glitches
        pageDots: true,
        prevNextButtons: true,
        draggable: true,
        imagesLoaded: true,
        setGallerySize: true,
        groupCells: false,
        percentPosition: false,  // Use pixel positioning
        adaptiveHeight: false,
        initialIndex: 0,
        resize: true,
        
        // More reasonable momentum settings
        freeScroll: false,
        friction: 0.28,  // Changed from 0.92 (too aggressive)
        selectedAttraction: 0.025,  // Changed from 0.2 (too snappy)
        dragThreshold: 3
      });

      // Remove the aggressive momentum stopping - let Flickity handle it naturally
      // The previous dragEnd handler was too aggressive
      
      // Force resize after initialization
      requestAnimationFrame(() => { 
        try { 
          flkty.resize();
          flkty.reposition();
        } catch(_){} 
      });
      
      // Additional resize after images might have loaded
      setTimeout(() => {
        try {
          flkty.resize();
          flkty.reposition();
        } catch(_){}
      }, 500);
    } catch (e) { 
      console.warn('Flickity init failed (Step 3):', e); 
    }
  }

  // Let Flickity receive events; then stop bubbling so parent cards don't steal them
  const wrap = step3.querySelector('.step3-format-carousel-wrapper');
  if (wrap) {
    const stopBubble = e => e.stopPropagation();
    ['click','mousedown','mouseup','touchstart','touchend','pointerdown','pointerup','dragstart']
      .forEach(ev => wrap.addEventListener(ev, stopBubble, { capture: false }));
  }

  // If Step 3 re-renders and removes our carousel, re-inject once
  const mo = new MutationObserver(() => {
    if (!document.getElementById(carouselId)) {
      mo.disconnect();
      // re-run after the DOM settles
      // setTimeout(injectStep3Carousel, 100);  // Reduced from 0 to 100ms for stability
      setTimeout(injectStep3ToggleImageViewer, 100);  // Reduced from 0 to 100ms for stability
    }
  });
  mo.observe(step3, { childList: true, subtree: true });
}

async function injectStep3ToggleImageViewer() {
  const step3 = document.getElementById('step3');
  if (!step3) return;

  // Determine the gift being personalised right now
  const gift =
    (typeof selectedGift !== 'undefined' && selectedGift) ? selectedGift
    : (selectedRecipient && recipientGifts?.[selectedRecipient.id]?.gift) || null;

  const category = gift?.category || window.tempGiftConfig?.category || '';
  const format   = gift?.format   || window.tempGiftConfig?.format   || '';
  const fallback = gift?.image    || window.tempGiftConfig?.image    || '';
  const sku      = gift?.sku      || window.tempGiftConfig?.sku      || '';

  // Wait for the Liquid form node
  const persForm = await waitForElementIn(step3, '.personalisation-form', 5000);
  if (!persForm) return; // form never showed up

  const containerId = 'step3-image-toggle';

  // Idempotent: remove old viewer if it exists
  const existingViewer = step3.querySelector(`#${containerId}`);
  if (existingViewer) {
    existingViewer.remove();
  }

  persForm.insertAdjacentHTML('beforebegin', buildStep3ToggleImageViewer(category, format, fallback, containerId, sku));

  // If Step 3 re-renders and removes our viewer, re-inject once
  const mo = new MutationObserver(() => {
    if (!document.getElementById(containerId)) {
      mo.disconnect();
      // re-run after the DOM settles
      setTimeout(injectStep3Carousel, 100);
    }
  });
  mo.observe(step3, { childList: true, subtree: true });
}

function resetToRecipientsList() {
    // Reset update flag (when coming back from review)
    isUpdatingFromStep4 = false;

    // Hide other steps, show the recipients list
    document.getElementById('step2').classList.add('hidden');
    document.getElementById('step3').classList.add('hidden');
    document.getElementById('step4').classList.add('hidden');
    document.getElementById('recipientsList').classList.remove('hidden');

    // Progress indicators
    document.getElementById('step1-progress').classList.add('completed');
    document.getElementById('step2-progress').classList.remove('active', 'completed');
    document.getElementById('step3-progress').classList.remove('active', 'completed');
    document.getElementById('step4-progress').classList.remove('active');

    // Clear transient data
    window.currentImageData = null;
    selectedGift = null;
    selectedRecipient = null;

    // Rebuild the clickable list (gift status will render inside selected item)
    renderRecipientSelectionList();

    // Hide CTAs until a recipient is selected
    const backBtn = document.getElementById('backToRecipientsBtn');
    if (backBtn) backBtn.classList.add('hidden');

    try { ensureNextButton(); } catch(_) {}
    }

function downloadTemplate() {
    // Create CSV content
    const csvContent = "Name,Email,Phone,Address\nJohn Doe,john@example.com,0412345678,\"123 Main St, Sydney NSW 2000\"";
    
    // Create download link
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'recipients_template.csv';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

// Helper: split a CSV line respecting quotes (simple, no escapes)
function parseCSVLine(line) {
  const out = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
    } else if (ch === ',' && !inQuotes) {
      out.push(cur);
      cur = '';
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out;
}

function importCSV(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = function(e) {
    const text = e.target.result || '';
    // Split lines robustly and drop empty ones
    const lines = text.split(/\r?\n/).filter(l => l.trim().length);

    // Skip header row; start at 1
    for (let i = 1; i < lines.length; i++) {
      const parts = parseCSVLine(lines[i].trim());
      if (parts.length >= 4) {
        const recipient = {
          id: Date.now() + i,
          name:  (parts[0] || '').replace(/^"|"$/g, ''),
          email: (parts[1] || '').replace(/^"|"$/g, ''),
          phone: (parts[2] || '').replace(/^"|"$/g, ''),
          // Join any leftover columns as address (handles extra commas in address)
          address: parts.slice(3).join(',').replace(/^"|"$/g, '')
        };
        recipients.push(recipient);
      }
    }

    updateStep1RecipientsList();
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();

    // Show the CTA only if we actually imported something
    if (recipients.length > 0) {
        const btn = document.getElementById('selectGiftsBtn');
        if (btn) btn.style.display = 'inline-block';
        
        // Hide the skip button when recipients exist
        const skipBtn = document.getElementById('skipRecipientsBtn');
        if (skipBtn) skipBtn.style.display = 'none';

        // Now that recipients are fully updated, proceed
        // scrollToTop();
        proceedToSelectGifts();
    }

    // collapse the bulk import div
    const bulkCollapseDiv = document.querySelector('details.bulk-import');
    if (bulkCollapseDiv) bulkCollapseDiv.open = false;
  };

  reader.readAsText(file);
}

function scrollToTop(smooth = true) {
  const behavior = smooth ? 'smooth' : 'auto';
  document.body.scrollTop = 0;            // for Safari
  document.documentElement.scrollTop = 0; // for Chrome, Firefox, IE and Opera
  window.scrollTo({ top: 0, behavior });
}

function goBack() {
    const step4 = document.getElementById('step4');
    const step3 = document.getElementById('step3');
    const step2 = document.getElementById('step2');
    
    if (!step4.classList.contains('hidden')) {
        step4.classList.add('hidden');
        document.getElementById('step4-progress').classList.remove('active');
    } else if (!step3.classList.contains('hidden')) {
        step3.classList.add('hidden');
        document.getElementById('step3-progress').classList.remove('active');
    } else if (!step2.classList.contains('hidden')) {
        step2.classList.add('hidden');
        document.getElementById('step2-progress').classList.remove('active');
    }
}

async function getProductVariantId(gift) {
  const giftHandle = gift?.giftHandle ? String(gift.giftHandle).trim() : "";
  const formatName = gift?.format     ? String(gift.format).trim()     : "";
  const category   = gift?.category   ? String(gift.category).trim()   : "";
  const explicitSku= gift?.sku        ? String(gift.sku).trim()        : "";
  const basePrice  = (typeof gift?.basePrice === 'number')
                      ? gift.basePrice
                      : (()=>{
                          const raw = String(gift?.basePrice ?? "").replace(/[^\d]/g, "");
                          return raw ? parseInt(raw, 10) : 0;
                        })();

  if (!giftHandle) {
    console.warn("getProductVariantId: missing giftHandle", gift);
    return null;
  }

  try {
    const res = await fetch(`/products/${encodeURIComponent(giftHandle)}.js`, { cache: "no-store" });
    if (!res.ok) {
      console.error(`getProductVariantId: HTTP ${res.status} for handle "${giftHandle}"`);
      return null;
    }

    let data;
    try { data = await res.json(); }
    catch (parseErr) { console.error("getProductVariantId: JSON parse error", parseErr); return null; }

    const variants = Array.isArray(data?.variants) ? data.variants : [];
    if (!variants.length) {
      console.warn("getProductVariantId: no variants on product", data?.handle || giftHandle);
      return null;
    }

    // 1) If an explicit SKU was provided on the gift, prefer that
    if (explicitSku) {
      const skuUpper = explicitSku.toUpperCase();
      const bySkuDirect = variants.find(v => String(v?.sku || '').toUpperCase() === skuUpper);
      if (bySkuDirect) return String(bySkuDirect.id);
    }

    // 2) Gift Cards: build expected SKU from format initial + basePrice
    const isGiftCard =
      category === 'Gift Cards' ||
      /(^|-)swap-gift-card($|-)/i.test(giftHandle) ||
      giftHandle === 'we-wander-swap-gift-card';

    if (isGiftCard && basePrice > 0) {
      const formatPrefix = (formatName || '').trim().charAt(0).toUpperCase() || 'D';
      const expectedSku  = `WEWANDER_SWAPGIFTCARD_${formatPrefix}_${basePrice}`;
      const bySku = variants.find(v => String(v?.sku || '').toUpperCase() === expectedSku);
      if (bySku) return String(bySku.id);
      console.warn('getProductVariantId: gift card SKU not found', { expectedSku, formatName, basePrice });
      // fall through
    }

    // 3) Fallbacks (non–gift card or SKU miss)
    let match = null;
    const target = (formatName || '').toLowerCase();
    if (target) {
      match = variants.find(v => typeof v?.title === "string" && v.title.toLowerCase().includes(target));
    }
    if (!match) match = variants.find(v => v?.title === "Default Title");
    if (!match) match = variants[0];

    return match?.id ? String(match.id) : null;
  } catch (err) {
    console.error("getProductVariantId: fetch error", err);
    return null;
  }
}


async function processToCart(orderData) {
  const items = [];

  for (const rg of Object.values(orderData.recipientGifts)) {
    const giftProps = {
      // recipient info
      "Recipient Full Name":    rg.recipient.name,
      "Recipient Email":        rg.recipient.email,
      "Recipient Phone":        rg.recipient.phone,

      // shipping info (for the gift card line)
      "Delivery Method":        rg.shipping.destination === "recipient" ? "To Recipient" : "To Office",
      "preferred delivery date": rg.shipping.date,
      "Address line 1":         rg.shipping.destination === "recipient" ? rg.shipping.address.line1 : "",
      "Address line 2":         rg.shipping.destination === "recipient" ? rg.shipping.address.line2 || "" : "",
      "City":                   rg.shipping.destination === "recipient" ? rg.shipping.address.suburb : "",
      "State":                  rg.shipping.destination === "recipient" ? rg.shipping.address.state : "",
      "Postcode":               rg.shipping.destination === "recipient" ? rg.shipping.address.postcode : "",
      "Country":                rg.shipping.destination === "recipient" ? rg.shipping.address.country : "",

      // personalisation
      "Greeting Message":       rg.personalisation.greetingMessage,
      "Personalised Message":   rg.personalisation.personalMessage,

      // order-level ref
      "Order Reference":        orderData.name
    };

    // Add the uploaded image URL if it exists
    if (rg.personalisation.coverImage && rg.personalisation.coverImage.serverUrl) {
      giftProps["image"] = rg.personalisation.coverImage.serverUrl;
    }

    // apply the discount on Activation Fee on Wine & Dine gift cards for PREMIUM_0525 
    const statusDiscounts = { signature_0825: 10, advantage_0825: 15, premium_0525: 15 };
    const statusDiscount = statusDiscounts[window.customerStatus];

    if(statusDiscount && rg.gift.sku && rg.gift.sku.includes('WEWANDER_SWAPGIFTCARD_')) {
      giftProps['Discount for Premium Account'] = statusDiscount;
    }

    let variantId = rg.gift.variant_id;
    if (!variantId) {
      variantId = await getProductVariantId({
        giftHandle: rg.gift.giftHandle || '',
        format:     rg.gift.format     || '',
        category:   rg.gift.category   || '',
        basePrice:  (typeof rg.gift.basePrice === 'number')
                      ? rg.gift.basePrice
                      : parseInt(String(rg.gift.basePrice || '').replace(/[^\d]/g, ''), 10) || 0,
        sku:        rg.gift.sku        || ''
      });
      rg.gift.variant_id = variantId;  // cache it
    }

    if (variantId) {
      items.push({
        id:         variantId,
        quantity:   1,
        properties: giftProps
      });
    }

    // ——— Optionally push shipping item ———
    if (rg.shipping.variant_id &&
      window.customerStatus != "signature_0825" && window.customerStatus != "premium_0525" && window.customerStatus != "advantage_0825" && window.customerStatus != "essence_0825"
    ) {
      const shipProps = {
        // you can pass along anything you like here
        "Recipient Full Name": rg.recipient.name,
        "Order Reference":     orderData.name,
        "Shipping Type":       rg.shipping.method || "",
        "Delivery Method":     rg.shipping.destination === "recipient" ? "To Recipient" : "To Office",
        "preferred delivery date": rg.shipping.date
      };

      items.push({
        id:         rg.shipping.variant_id,
        quantity:   1,
        properties: shipProps
      });
    }

    // NOTE: Express fee is already included in the shipping variant above (rg.shipping.variant_id)
    // so we don't need to add a separate express fee line item
    // Removed duplicate express fee addition to prevent double charging
    /*
    if(rg.shipping.express_fee > 0) {
      items.push({
        id:         45962140254460, // express delivery fee item
        quantity:   1
      });
    }
    */
  }

  try {
    const resp = await fetch("/cart/add.js", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ items })
    });
    if (!resp.ok) throw new Error("Shopify cart add failed");
    await resp.json();
    if (window.__giftDraft__) window.__giftDraft__.clearDraftEverywhere();
    resetForm();
    window.location.href = "/cart";
  } catch (err) {
    console.error("Error adding items to cart:", err);
  }
}

/**
* Gather every recipient's shipping address (if sending direct)
* then push the order into cart.
*/
async function addToCart() {
  try {
    // First, validate digital gifts with placeholder recipients
    for (const id of Object.keys(recipientGifts)) {
      const giftData = recipientGifts[id];

      if (isChristmasBlockActive() && !isAllowedGift(giftData?.gift)) {
        showHtmlAlert(
          "🎄 Christmas Break Notice\n\n" +
          "Only Digital Experience Collections are available to order during this period.\n"
        );
        return;
      }

      const recipient = recipients.find(r => r.id == id);
      
      if (!recipient) {
        console.warn(`Recipient with id ${id} not found in recipients array`);
        continue;
      }
      
      const isDigital = ((giftData?.gift?.format || '').toLowerCase() === 'digital');
      const isPlaceholder = isPlaceholderRecipient(recipient);

      if (isDigital && isPlaceholder) {
        // Get the values from the required fields
        const nameInput = document.getElementById(`recipient-name-${id}`);
        const emailInput = document.getElementById(`recipient-email-${id}`);
        
        if (!nameInput || !emailInput) {
          showHtmlAlert("Missing recipient information fields. Please refresh the page and try again.");
          throw new Error("Missing recipient information fields");
        }

        const recipientName = nameInput.value.trim();
        const recipientEmail = emailInput.value.trim();

        // Validate name
        if (!recipientName || recipientName.length < 2) {
          showHtmlAlert("Please provide a valid full name for the recipient of the digital gift.");
          nameInput.focus();
          throw new Error("Invalid recipient name");
        }

        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!recipientEmail || !emailRegex.test(recipientEmail)) {
          showHtmlAlert("Please provide a valid email address for the recipient of the digital gift.");
          emailInput.focus();
          throw new Error("Invalid recipient email");
        }

        // Update the recipient object with validated information
        recipient.name = recipientName;
        recipient.email = recipientEmail;
        recipient.isPlaceholder = false; // No longer a placeholder
        
        // Update the gift data recipient reference
        giftData.recipient.name = recipientName;
        giftData.recipient.email = recipientEmail;
        
        // Ensure shipping address has the email
        if (!giftData.shipping.address) {
          giftData.shipping.address = {};
        }
        giftData.shipping.address.email = recipientEmail;
      }

      // Continue with existing shipping address collection
      // Ensure shipping object exists with defaults
      if (!recipientGifts[id].shipping) {
        const isDigital = ((recipientGifts[id]?.gift?.format || '').toLowerCase() === 'digital');
        recipientGifts[id].shipping = {
          method: 'now',
          date: null,
          destination: isDigital ? 'recipient' : 'office',
          address: {},
          express_fee: 0,
          variant_id: null
        };
      }
      
      const r = recipientGifts[id].shipping;
      const isDigitalGift = ((recipientGifts[id]?.gift?.format || '').toLowerCase() === 'digital');

      // For digital gifts or recipient destination, collect address
      if (r.destination === 'recipient' || isDigitalGift) {
        if (isDigitalGift) {
          // For digital gifts, email might already be set from placeholder validation
          if (!r.address.email) {
            const recipientObj = recipients.find(rec => rec.id == id);
            const emailVal = document.getElementById(`email-${id}`)?.value.trim() || 
                           (recipientObj ? recipientObj.email : '') || '';
            if (!emailVal) {
              const recipientName = recipientObj ? recipientObj.name : "this recipient";
              showHtmlAlert("Please provide a valid email address for " + recipientName);
              throw new Error("Missing required recipient email");
            }
            r.address = { email: emailVal };
          }
        } else {
          r.address = {
            line1:   document.getElementById(`street-${id}`).value,
            line2:   document.getElementById(`unit-${id}`).value,
            suburb:  document.getElementById(`suburb-${id}`).value,
            state:   document.getElementById(`state-${id}`).value,
            postcode:document.getElementById(`postcode-${id}`).value,
            country: document.getElementById(`country-${id}`).value,
          };
        }
      }
    }

    const orderData = {
      name: document.getElementById('orderName').value,
      totalRecipients: Object.keys(recipientGifts).length,
      totalAmount: Object.values(recipientGifts).reduce((s, i) => s + i.gift.price + (i.shipping.express_fee || 0), 0),
      recipientGifts,
      createdAt: new Date().toISOString()
    };

    cart.push(orderData);
    await processToCart(orderData);
  }
  catch (err) {
    console.error(err);
    if (!err.message.includes("Invalid recipient") && !err.message.includes("Missing required")) {
      showHtmlAlert("There's a technical issue…");
    }
  }
}

function resetForm() {
    // Reset the update flag
    isUpdatingFromStep4 = false;
    
    // Reset all sections to initial state
    document.getElementById('step1').style.display = 'block';
    document.getElementById('recipientsList').classList.add('hidden');
    document.getElementById('step2').classList.add('hidden');
    document.getElementById('step3').classList.add('hidden');
    document.getElementById('step4').classList.add('hidden');
    
    // Reset progress bar
    document.querySelectorAll('.progress-step').forEach(step => {
        step.classList.remove('active', 'completed');
    });
    document.getElementById('step1-progress').classList.add('active');
    
    // Clear form data
    document.getElementById('orderName').value = '';
    document.getElementById('recipientForm').reset();
    recipients = [];
    selectedRecipient = null;
    selectedGift = null;
    recipientGifts = {};
    window.currentImageData = null;
    
    // Reset upload area
    const uploadContent = document.getElementById('uploadContent');
    if (uploadContent) {
        uploadContent.innerHTML = '<p>Click to upload image</p>';
    }
    const uploadArea = document.getElementById('uploadArea');
    if (uploadArea) {
        uploadArea.classList.remove('has-content');
    }
    
    updateStep1RecipientsList();
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();
    document.getElementById('selectGiftsBtn').style.display = 'none';
}

// Initialize
window.addEventListener('click', function(e) {
    if (e.target.classList.contains('modal')) {
        closeModal();
    }
});

/* ===== Force-inject Copy Gift buttons (safety net) ===== */
function ensureCopyButtons() {
  const statusBlocks = document.querySelectorAll('.recipient-gift-status');
  statusBlocks.forEach(block => {
    // Avoid duplicates
    if (block.querySelector('[data-action="copy-gift"]')) return;

    // Find recipient id from the closest parent having data-id (as used in recipient list)
    let rEl = block.closest('[data-id]');
    let rid = rEl ? rEl.getAttribute('data-id') : (selectedRecipient ? selectedRecipient.id : null);
    if (!rid) return;

    // Only show if we have a gift in memory for this recipient
    if (!recipientGifts[rid]) return;

    const btnBar = block.querySelector('div[style*="display:flex"]') || block;
    const btn = document.createElement('button');
    btn.className = 'btn btn-secondary';
    btn.setAttribute('data-action', 'copy-gift');
    btn.style.cssText = 'padding:6px 12px;font-size:12px;margin-left:6px;';
    btn.textContent = 'Copy Gift';
    btn.addEventListener('click', (e) => { e.stopPropagation(); callCopyRecipientGift(parseInt(rid,10)); });
    btnBar.appendChild(btn);
  });
}

(function attachCopyButtonObserver(){
  if (!window.__copyBtnObserverAttached) {
    window.__copyBtnObserverAttached = true;
    const mo = new MutationObserver(() => { ensureCopyButtons(); });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', ensureCopyButtons);
    window.addEventListener('load', ensureCopyButtons);
  }
})();



/* === Global exposure shim for copy/paste/edit === */
(function(){
  function callCopyRecipientGift(rid){
    if (typeof copyRecipientGift === 'function') return copyRecipientGift(rid);
    if (typeof window !== 'undefined' && typeof window.copyRecipientGift === 'function') return window.copyRecipientGift(rid);
    console.warn('copyRecipientGift is not available on this page.');
  }
  if (typeof window !== 'undefined') {
    if (typeof copyRecipientGift === 'function') window.copyRecipientGift = copyRecipientGift;
    if (typeof pasteGiftToRecipient === 'function') window.pasteGiftToRecipient = pasteGiftToRecipient;
    if (typeof editRecipientGift === 'function') window.editRecipientGift = editRecipientGift;
    window.callCopyRecipientGift = callCopyRecipientGift;
  } else {
    // non-browser environment
    globalThis.callCopyRecipientGift = callCopyRecipientGift;
  }
})();



/* === Helper: deep clone === */
const deepClone = (obj) => JSON.parse(JSON.stringify(obj));


/* === Clipboard for copy/paste === */
let copiedGiftPayload = null; // { sourceRecipientId, giftData }


/* === Copy / Paste Gift core === */
function copyRecipientGift(recipientId) {
  try {
    const src = recipientGifts[recipientId];
    if (!src) { showHtmlAlert && showHtmlAlert('No gift to copy for this recipient.'); return; }
    copiedGiftPayload = { sourceRecipientId: recipientId, giftData: deepClone(src) };
    if (typeof renderRecipientSelectionList === 'function') { try { renderRecipientSelectionList(); } catch(_) {} }
    if (typeof showHtmlToast === 'function') { try { showHtmlToast('Gift copied. Select another recipient and click "Paste Gift".'); } catch(_) {} }
    if (typeof ensurePasteButtons === 'function') { try { ensurePasteButtons(); } catch(_) {} }
  } catch (err) {
    console.warn('copyRecipientGift error:', err);
  }
}

function pasteGiftToRecipient(targetRecipientId) {
  try {
    if (!copiedGiftPayload) return;
    const targetRecipient = (recipients || []).find(r => r.id == targetRecipientId);
    if (!targetRecipient) return;
    const cloned = deepClone(copiedGiftPayload.giftData);
    cloned.recipient = {
      id: targetRecipient.id,
      name: targetRecipient.name,
      email: targetRecipient.email,
      phone: targetRecipient.phone,
      address: targetRecipient.address
    };
    cloned.shipping = cloned.shipping || { method: 'now', date: null, destination: 'office', address: {} };
    recipientGifts[targetRecipientId] = cloned;
    selectedRecipient = targetRecipient;
    if (typeof renderRecipientSelectionList === 'function') { try { renderRecipientSelectionList(); } catch(_) {} }
    if (typeof showHtmlToast === 'function') { try { showHtmlToast('Gift pasted to ' + (targetRecipient.name || 'recipient') + '.'); } catch(_) {} }
    
    // now autosave the draft
    if (window.__giftDraft__) window.__giftDraft__.queueAutosave();

    try { ensureNextButton(); } catch(_) {}
  } catch (err) {
    console.warn('pasteGiftToRecipient error:', err);
  }
}


/* ===== Force-inject Paste Gift buttons (safety net) ===== */
function ensurePasteButtons() {
  if (!copiedGiftPayload) return;
  const list = document.getElementById('recipientSelectList') || document;
  const items = list.querySelectorAll('[data-id]');
  items.forEach(item => {
    const rid = item.getAttribute('data-id');
    if (!rid || String(rid) === String(copiedGiftPayload.sourceRecipientId)) return;
    // Avoid if paste already present
    if (item.querySelector('[data-action="paste-gift"]')) return;
    // Create a small button near recipient info
    // const info = item.querySelector('.recipient-info') || item;
    const btnContainer = item.querySelector('#recipient-gift-action-btn-container') || item;
    const btn = document.createElement('button');
    btn.className = 'btn btn-secondary';
    btn.setAttribute('data-action', 'paste-gift');
    btn.style.cssText = 'padding:6px 12px;font-size:12px;';
    btn.textContent = 'Paste Gift';
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      callPasteGiftToRecipient(parseInt(rid, 10));
    });
    // info.appendChild(btn);
    btnContainer.appendChild(btn);
  });
}

// Helper function to upload file to server
async function _storeUploadFile(file, filename) {
    return new Promise((resolve, reject) => {
        let req = new XMLHttpRequest();
        let formData = new FormData();
        formData.append('timestamp', window.timestamp);
        formData.append('orderpin', window.passpin);
        formData.append('type', 'personalisedImg');
        formData.append('file', file);
        formData.append("filename", filename);
        
        req.open("POST", 'https://www.we-wa.com.au/wp-content/themes/golo/inc/greetingVideoMessage/upload.php');
        
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200 || req.status === 0) {
                    resolve(req.responseText);
                } else {
                    reject(new Error("Request failed: " + req.statusText));
                }
            }
        };
        
        req.onerror = function() {
            reject(new Error("Network error"));
        };
        
        req.send(formData);
    });
}


(function attachPasteButtonObserver(){
  if (!window.__pasteBtnObserverAttached) {
    window.__pasteBtnObserverAttached = true;
    const mo2 = new MutationObserver(() => { try { ensurePasteButtons(); } catch(_) {} });
    mo2.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', () => { try { ensurePasteButtons(); } catch(_) {} });
    window.addEventListener('load', () => { try { ensurePasteButtons(); } catch(_) {} });
  }
})();


/* === Global shim updates === */
(function(){
  function callCopyRecipientGift(rid){
    if (typeof copyRecipientGift === 'function') return copyRecipientGift(rid);
    if (typeof window !== 'undefined' && typeof window.copyRecipientGift === 'function') return window.copyRecipientGift(rid);
    console.warn('copyRecipientGift is not available on this page.');
  }
  function callPasteGiftToRecipient(rid){
    if (typeof pasteGiftToRecipient === 'function') return pasteGiftToRecipient(rid);
    if (typeof window !== 'undefined' && typeof window.pasteGiftToRecipient === 'function') return window.pasteGiftToRecipient(rid);
    console.warn('pasteGiftToRecipient is not available on this page.');
  }
  if (typeof window !== 'undefined') {
    if (typeof copyRecipientGift === 'function') window.copyRecipientGift = copyRecipientGift;
    if (typeof pasteGiftToRecipient === 'function') window.pasteGiftToRecipient = pasteGiftToRecipient;
    window.callCopyRecipientGift = callCopyRecipientGift;
    window.callPasteGiftToRecipient = callPasteGiftToRecipient;
  } else {
    globalThis.callCopyRecipientGift = callCopyRecipientGift;
    globalThis.callPasteGiftToRecipient = callPasteGiftToRecipient;
  }
})();